{
 "schema": "ft.janus.c2-pl-cost-contract.v1",
 "sources": {
  "pl_cost": "e1e8fab88bbd0396",
  "additions": "c0ddfcb1652eaa61",
  "status_effect": "08158b48d100f7be",
  "pl_engine": "8f4108cd3b0b6888"
 },
 "plCosts": {
  "essences": {
   "divisor": 1,
   "stackable": {
    "body": 7500,
    "mind": 7500,
    "soul": 7500,
    "spirit": 1000,
    "fortune": 2500
   },
   "fixed": {
    "body": 2500,
    "mind": 2500,
    "soul": 2500,
    "spirit": 500,
    "fortune": 3000
   }
  },
  "senses": {
   "divisor": 5,
   "stackable": {
    "nightsight": 100,
    "blindsight": 500,
    "fiendsight": 750,
    "ghostsight": 750,
    "spellsight": 500,
    "truesight": 1500,
    "tremorsense": 500,
    "telepathy": 300,
    "windsense": 500
   },
   "fixed": {
    "nightsight": 200,
    "blindsight": 1000,
    "fiendsight": 1500,
    "ghostsight": 1500,
    "spellsight": 1000,
    "truesight": 3000,
    "tremorsense": 1000,
    "telepathy": 600,
    "windsense": 1000
   }
  },
  "speed_types": {
   "divisor": 5,
   "stackable": {
    "speed_walking": 900,
    "speed_jumping": 700,
    "speed_swimming": 1100,
    "speed_climbing": 800,
    "speed_flying": 1800,
    "speed_burrowing": 1400,
    "speed_hovering": 1300,
    "teleport": 3000
   }
  },
  "speed_change_remaining": {
   "divisor": 5,
   "stackable": {
    "change_speed_walking_remaining": 250,
    "change_speed_jumping_remaining": 280,
    "change_speed_climbing_remaining": 400,
    "change_speed_swimming_remaining": 300,
    "change_speed_flying_remaining": 600,
    "change_speed_hovering_remaining": 500,
    "change_speed_burrowing_remaining": 500,
    "change_teleport_remaining": 800
   }
  },
  "special": {
   "caster_moves_towards_target_in_ft": 500,
   "caster_moves_to_end_point_of_aoe_effect_after_cast": 300,
   "caster_dive_bombs_target": 400,
   "lockpick_effective_skill_tier_bonus": 2000,
   "lockpick_sweet_spot_changed_by_percentage": 1000,
   "lockpick_pick_durability_changed_by_percentage": 600
  },
  "status_effects": {
   "contesting_roll_adv_vs_status_effect": {
    "deafened": 2500,
    "diseased": 5000,
    "poisoned": 5000,
    "food_poisoning": 1000,
    "prone": 1000,
    "sleeping": 4000,
    "suffocating": 2500,
    "drowning": 2500,
    "surprised": 3000,
    "unconscious": 5000,
    "truthsayer": 1500,
    "repelled": 2500,
    "silenced": 3000,
    "withering": 5000,
    "challenged": 1000,
    "confused": 5000,
    "feebleminded": 5000,
    "soul_breaker": 5000,
    "unimpeded": 0,
    "reckless": 500,
    "concentrating": 1500,
    "consecrated": 1500,
    "frightened": 5000,
    "incorporeal": 1000,
    "spell_locked": 5000,
    "inverted": 5000,
    "fleeing": 1500,
    "holy_turned": 2500,
    "disguised": 500,
    "trackers_brand": 0,
    "weary": 1000,
    "slightly_drunk": 500,
    "drunk": 1000,
    "burning": 1500,
    "melting": 3000,
    "corroding": 3000,
    "dissolving": 5000,
    "wet": 500,
    "chilled": 1000,
    "freezing": 1500,
    "frozen": 5000,
    "blinded": 3000,
    "photosensitive_eye_strain": 2500,
    "extreme_photosensitive_eye_strain": 3000,
    "parched": 500,
    "desiccating": 1000,
    "starving": 2000,
    "petrified": 2500,
    "petrifying": 500,
    "bleeding": 500,
    "moderate_bleeding": 1500,
    "severe_bleeding": 3000,
    "maimed": 5000,
    "blighted": 3000,
    "exhausted": 2500,
    "paralyzed": 5000,
    "banished": 2500,
    "stunned": 3000,
    "dazed": 1000,
    "backlash": 500,
    "charmed": 1500,
    "dominated": 5000,
    "possessed": 3000,
    "grappled": 500,
    "restrained": 3000,
    "immobile": 1500,
    "slowed": 3000,
    "hindered": 1500,
    "hamstrung": 500,
    "sluggish": 1000,
    "dizzy": 500,
    "staggered": 2000,
    "impaired": 3000,
    "exposed": 1000,
    "squeezed": 1500,
    "very_squeezed": 1500,
    "weakened": 1000,
    "greater_weakened": 2500,
    "enfeebled": 3000,
    "defenseless": 1500,
    "vulnerable": 3000
   },
   "contesting_roll_dis_vs_status_effect": {
    "deafened": -2500,
    "diseased": -5000,
    "poisoned": -5000,
    "food_poisoning": -1000,
    "prone": -1000,
    "sleeping": -4000,
    "suffocating": -2500,
    "drowning": -2500,
    "surprised": -3000,
    "unconscious": -5000,
    "truthsayer": -1500,
    "repelled": -2500,
    "silenced": -3000,
    "withering": -5000,
    "challenged": -1000,
    "confused": -5000,
    "feebleminded": -5000,
    "soul_breaker": -5000,
    "unimpeded": 0,
    "reckless": -500,
    "concentrating": -1500,
    "consecrated": -1500,
    "frightened": -5000,
    "incorporeal": -1000,
    "spell_locked": -5000,
    "inverted": -5000,
    "fleeing": -1500,
    "holy_turned": -2500,
    "disguised": -500,
    "trackers_brand": 0,
    "weary": -1000,
    "slightly_drunk": -500,
    "drunk": -1000,
    "burning": -1500,
    "melting": -3000,
    "corroding": -3000,
    "dissolving": -5000,
    "wet": -500,
    "chilled": -1000,
    "freezing": -1500,
    "frozen": -5000,
    "blinded": -3000,
    "photosensitive_eye_strain": -2500,
    "extreme_photosensitive_eye_strain": -3000,
    "parched": -500,
    "desiccating": -1000,
    "starving": -2000,
    "petrified": -2500,
    "petrifying": -500,
    "bleeding": -500,
    "moderate_bleeding": -1500,
    "severe_bleeding": -3000,
    "maimed": -5000,
    "blighted": -3000,
    "exhausted": -2500,
    "paralyzed": -5000,
    "banished": -2500,
    "stunned": -3000,
    "dazed": -1000,
    "backlash": -500,
    "charmed": -1500,
    "dominated": -5000,
    "possessed": -3000,
    "grappled": -500,
    "restrained": -3000,
    "immobile": -1500,
    "slowed": -3000,
    "hindered": -1500,
    "hamstrung": -500,
    "sluggish": -1000,
    "dizzy": -500,
    "staggered": -2000,
    "impaired": -3000,
    "exposed": -1000,
    "squeezed": -1500,
    "very_squeezed": -1500,
    "weakened": -1000,
    "greater_weakened": -2500,
    "enfeebled": -3000,
    "defenseless": -1500,
    "vulnerable": -3000
   },
   "immune_to_status_effect": {
    "deafened": 7500,
    "diseased": 15000,
    "poisoned": 15000,
    "food_poisoning": 3000,
    "prone": 3000,
    "sleeping": 12000,
    "suffocating": 7500,
    "drowning": 7500,
    "surprised": 9000,
    "unconscious": 15000,
    "truthsayer": 4500,
    "repelled": 7500,
    "silenced": 9000,
    "withering": 15000,
    "challenged": 3000,
    "confused": 15000,
    "feebleminded": 15000,
    "soul_breaker": 15000,
    "unimpeded": -1500,
    "reckless": 1000,
    "consecrated": 4500,
    "frightened": 15000,
    "incorporeal": -3000,
    "spell_locked": 15000,
    "inverted": 15000,
    "fleeing": 4500,
    "holy_turned": 7500,
    "disguised": -1000,
    "trackers_brand": 5000,
    "weary": 3000,
    "slightly_drunk": 1500,
    "drunk": 3000,
    "burning": 5000,
    "melting": 9000,
    "corroding": 9000,
    "dissolving": 15000,
    "wet": 1500,
    "chilled": 3000,
    "freezing": 5000,
    "frozen": 15000,
    "blinded": 9000,
    "photosensitive_eye_strain": 7500,
    "extreme_photosensitive_eye_strain": 9000,
    "parched": 5000,
    "desiccating": 7500,
    "starving": 10000,
    "petrified": 10000,
    "petrifying": 1500,
    "bleeding": 2000,
    "moderate_bleeding": 5000,
    "severe_bleeding": 9000,
    "maimed": 15000,
    "blighted": 12000,
    "exhausted": 10000,
    "paralyzed": 15000,
    "banished": 8000,
    "stunned": 10000,
    "dazed": 5000,
    "backlash": 1500,
    "charmed": 7500,
    "dominated": 15000,
    "possessed": 9000,
    "grappled": 5000,
    "restrained": 10000,
    "immobile": 5000,
    "slowed": 10000,
    "hindered": 5000,
    "hamstrung": 1500,
    "sluggish": 3000,
    "dizzy": 1500,
    "staggered": 7500,
    "impaired": 10000,
    "exposed": 5000,
    "squeezed": 6000,
    "very_squeezed": 6000,
    "protected": -3000,
    "powerful": -2500,
    "greater_powerful": -5000,
    "empowered": -3000,
    "shelled": -2500,
    "resistant": -5000,
    "invulnerable": -10000,
    "hidden": -5000,
    "invisible": -2500,
    "greater_invisible": -3000,
    "ethereal": -1000,
    "flanked": 5000,
    "rushed": -2500,
    "hasted": -2500,
    "vulnerable": 10000,
    "weakened": 7500,
    "greater_weakened": 12000,
    "defenseless": 12000,
    "enfeebled": 7500,
    "electrocuted": 5000,
    "shocked": 5000,
    "crippled": 10000,
    "blighted_2": 4000,
    "blighted_5": 8000,
    "blighted_9": 12000,
    "blighted_10": 13000,
    "dying": 15000,
    "dying_state_1": 3000,
    "dying_state_2": 4500,
    "dying_state_3": 6000,
    "dead": 25000,
    "judgement": 2000,
    "judgement_1": 2000,
    "judgement_2": 4000,
    "judgement_3": 6000,
    "grappling": 1500,
    "concentrating": 4500,
    "locked": 1500,
    "thirsty": 2000,
    "shielded": -2500,
    "shielded_2": -3500,
    "shielded_3": -4500,
    "shielded_5": -6500,
    "shielded_10": -10000,
    "stabilized": -2000,
    "bolstered": -2500,
    "ageless": -1000,
    "nondetection_effect": -3000,
    "mirror_image_1": -2500,
    "mirror_image_2": -3500,
    "mirror_image_3": -4500,
    "mirror_image_effect": -2500,
    "shadowform": -3000,
    "partial_cover": -1500,
    "spider_climb_effect": -1500,
    "performing_a_melody": -1000,
    "holding_mastery": -1000,
    "recovery_state_1": -1000,
    "recovery_state_2": -1500,
    "recovery_state_3": -2000,
    "fate_card_suit_war": -1000,
    "fate_card_suit_change": -1000,
    "fate_card_suit_prosperity": -1000,
    "fate_card_suit_love": -1000
   },
   "status_effect_permanent": {
    "deafened": -7500,
    "diseased": -15000,
    "poisoned": -15000,
    "food_poisoning": -3000,
    "prone": -3000,
    "sleeping": -12000,
    "suffocating": -7500,
    "drowning": -7500,
    "surprised": -9000,
    "unconscious": -15000,
    "truthsayer": -4500,
    "repelled": -7500,
    "silenced": -9000,
    "withering": -15000,
    "challenged": -3000,
    "confused": -15000,
    "feebleminded": -15000,
    "soul_breaker": -15000,
    "unimpeded": 15000,
    "reckless": 3000,
    "consecrated": -4500,
    "frightened": -15000,
    "incorporeal": 5000,
    "spell_locked": -15000,
    "inverted": -15000,
    "fleeing": -4500,
    "holy_turned": -7500,
    "disguised": 2500,
    "ageless": 2500,
    "nondetection_effect": 25000,
    "partial_cover": 3000,
    "spider_climb_effect": 15000,
    "bolstered": 5000,
    "trackers_brand": -5000,
    "weary": -3000,
    "slightly_drunk": -1500,
    "drunk": -3000,
    "burning": -5000,
    "melting": -9000,
    "corroding": -9000,
    "dissolving": -15000,
    "wet": -1500,
    "chilled": -3000,
    "freezing": -5000,
    "frozen": -15000,
    "blinded": -9000,
    "photosensitive_eye_strain": -7500,
    "extreme_photosensitive_eye_strain": -9000,
    "water_walk_effect": 10000,
    "obscured": 30000,
    "sneaking": 0,
    "hidden": 30000,
    "greater_invisible": 50000,
    "ethereal": 30000,
    "flanked": -7500,
    "rushed": 15000,
    "hasted": 20000,
    "protected": 10000,
    "powerful": 10000,
    "greater_powerful": 25000,
    "empowered": 7500,
    "shelled": 10000,
    "resistant": 50000,
    "invulnerable": 100000,
    "parched": -5000,
    "desiccating": -7500,
    "starving": -10000,
    "petrified": -10000,
    "petrifying": -1500,
    "bleeding": -2000,
    "moderate_bleeding": -5000,
    "severe_bleeding": -9000,
    "maimed": -15000,
    "blighted": -12000,
    "exhausted": -10000,
    "paralyzed": -15000,
    "banished": -8000,
    "stunned": -10000,
    "dazed": -5000,
    "backlash": -1500,
    "charmed": -7500,
    "dominated": -15000,
    "possessed": -9000,
    "grappled": -5000,
    "restrained": -10000,
    "immobile": -15000,
    "slowed": -10000,
    "hindered": -5000,
    "hamstrung": -1500,
    "sluggish": -3000,
    "dizzy": -1500,
    "staggered": -7500,
    "impaired": -10000,
    "exposed": -5000,
    "squeezed": -6000,
    "very_squeezed": -6000,
    "weakened": -5000,
    "greater_weakened": -7500,
    "enfeebled": -9000,
    "defenseless": -5000,
    "vulnerable": -15000
   }
  },
  "skill_roll_modifiers": {
   "skill_roll_adv": {
    "balance": 7500,
    "fortitude": 7500,
    "willpower": 7500,
    "psyche": 7500,
    "attention": 5000,
    "empathy": 5000,
    "frighten": 5000,
    "influence": 5000,
    "initiative": 5000,
    "inspection": 5000,
    "sneak": 5000,
    "excavating": 3000,
    "farming": 3000,
    "fishing": 3000,
    "herbalism": 3000,
    "hunting": 3000,
    "locks": 3000,
    "mining": 3000,
    "skinning": 3000,
    "architecture": 3000,
    "astronomy": 3000,
    "biology": 3000,
    "civics": 3000,
    "finance": 3000,
    "gamesmanship": 3000,
    "geology": 3000,
    "history": 3000,
    "law": 3000,
    "linguistics": 3000,
    "magic": 4000,
    "medicine": 3000,
    "music": 3000,
    "navigation": 3000,
    "planes": 3000,
    "religion": 3000,
    "alchemy": 3000,
    "art": 3000,
    "cooking": 3000,
    "enchanting": 3000,
    "glassblowing": 3000,
    "jewelling": 3000,
    "leatherworking": 3000,
    "machining": 3000,
    "masoning": 3000,
    "smithing": 3000,
    "weaving": 3000,
    "woodworking": 3000,
    "archery_weapon_skill": 10000,
    "bending_weapon_skill": 10000,
    "firearms_weapon_skill": 10000,
    "natural_weapon_skill": 10000,
    "one_handed_melee_weapon_skill": 10000,
    "throwable_weapon_skill": 10000,
    "two_handed_melee_weapon_skill": 10000,
    "heavy_armor_skill": 2500,
    "light_armor_skill": 2500,
    "medium_armor_skill": 2500,
    "natural_armor_skill": 2500,
    "shield_armor_skill": 2500
   },
   "skill_roll_ignore_dis": {
    "balance": 7500,
    "fortitude": 7500,
    "willpower": 7500,
    "psyche": 7500,
    "attention": 5000,
    "empathy": 5000,
    "frighten": 5000,
    "influence": 5000,
    "initiative": 5000,
    "inspection": 5000,
    "sneak": 5000,
    "excavating": 3000,
    "farming": 3000,
    "fishing": 3000,
    "herbalism": 3000,
    "hunting": 3000,
    "locks": 3000,
    "mining": 3000,
    "skinning": 3000,
    "architecture": 3000,
    "astronomy": 3000,
    "biology": 3000,
    "civics": 3000,
    "finance": 3000,
    "gamesmanship": 3000,
    "geology": 3000,
    "history": 3000,
    "law": 3000,
    "linguistics": 3000,
    "magic": 4000,
    "medicine": 3000,
    "music": 3000,
    "navigation": 3000,
    "planes": 3000,
    "religion": 3000,
    "alchemy": 3000,
    "art": 3000,
    "cooking": 3000,
    "enchanting": 3000,
    "glassblowing": 3000,
    "jewelling": 3000,
    "leatherworking": 3000,
    "machining": 3000,
    "masoning": 3000,
    "smithing": 3000,
    "weaving": 3000,
    "woodworking": 3000,
    "archery_weapon_skill": 10000,
    "bending_weapon_skill": 10000,
    "firearms_weapon_skill": 10000,
    "natural_weapon_skill": 10000,
    "one_handed_melee_weapon_skill": 10000,
    "throwable_weapon_skill": 10000,
    "two_handed_melee_weapon_skill": 10000,
    "heavy_armor_skill": 2500,
    "light_armor_skill": 2500,
    "medium_armor_skill": 2500,
    "natural_armor_skill": 2500,
    "shield_armor_skill": 2500
   },
   "skill_roll_dis": {
    "balance": -7500,
    "fortitude": -7500,
    "willpower": -7500,
    "psyche": -7500,
    "attention": -5000,
    "empathy": -5000,
    "frighten": -5000,
    "influence": -5000,
    "initiative": -5000,
    "inspection": -5000,
    "sneak": -5000,
    "excavating": -3000,
    "farming": -3000,
    "fishing": -3000,
    "herbalism": -3000,
    "hunting": -3000,
    "locks": -3000,
    "mining": -3000,
    "skinning": -3000,
    "architecture": -3000,
    "astronomy": -3000,
    "biology": -3000,
    "civics": -3000,
    "finance": -3000,
    "gamesmanship": -3000,
    "geology": -3000,
    "history": -3000,
    "law": -3000,
    "linguistics": -3000,
    "magic": -4000,
    "medicine": -3000,
    "music": -3000,
    "navigation": -3000,
    "planes": -3000,
    "religion": -3000,
    "alchemy": -3000,
    "art": -3000,
    "cooking": -3000,
    "enchanting": -3000,
    "glassblowing": -3000,
    "jewelling": -3000,
    "leatherworking": -3000,
    "machining": -3000,
    "masoning": -3000,
    "smithing": -3000,
    "weaving": -3000,
    "woodworking": -3000,
    "archery_weapon_skill": -10000,
    "bending_weapon_skill": -10000,
    "firearms_weapon_skill": -10000,
    "natural_weapon_skill": -10000,
    "one_handed_melee_weapon_skill": -10000,
    "throwable_weapon_skill": -10000,
    "two_handed_melee_weapon_skill": -10000,
    "heavy_armor_skill": -2500,
    "light_armor_skill": -2500,
    "medium_armor_skill": -2500,
    "natural_armor_skill": -2500,
    "shield_armor_skill": -2500
   },
   "skill_roll_mod_plus1": {
    "balance": 2500,
    "fortitude": 2500,
    "willpower": 2500,
    "psyche": 2500,
    "attention": 2000,
    "empathy": 2000,
    "frighten": 2000,
    "influence": 2000,
    "initiative": 2000,
    "inspection": 2000,
    "sneak": 2000,
    "excavating": 1000,
    "farming": 1000,
    "fishing": 1000,
    "herbalism": 1000,
    "hunting": 1000,
    "locks": 1000,
    "mining": 1000,
    "skinning": 1000,
    "architecture": 1000,
    "astronomy": 1000,
    "biology": 1000,
    "civics": 1000,
    "finance": 1000,
    "gamesmanship": 1000,
    "geology": 1000,
    "history": 1000,
    "law": 1000,
    "linguistics": 1000,
    "magic": 1000,
    "medicine": 1000,
    "music": 1000,
    "navigation": 1000,
    "planes": 1000,
    "religion": 1000,
    "alchemy": 1000,
    "art": 1000,
    "cooking": 1000,
    "enchanting": 1000,
    "glassblowing": 1000,
    "jewelling": 1000,
    "leatherworking": 1000,
    "machining": 1000,
    "masoning": 1000,
    "smithing": 1000,
    "weaving": 1000,
    "woodworking": 1000,
    "archery_weapon_skill": 2500,
    "bending_weapon_skill": 2500,
    "firearms_weapon_skill": 2500,
    "natural_weapon_skill": 2500,
    "one_handed_melee_weapon_skill": 2500,
    "throwable_weapon_skill": 2500,
    "two_handed_melee_weapon_skill": 2500,
    "heavy_armor_skill": 1000,
    "light_armor_skill": 1000,
    "medium_armor_skill": 1000,
    "natural_armor_skill": 1000,
    "shield_armor_skill": 1000
   },
   "skill_roll_mod_minus1": {
    "balance": -2500,
    "fortitude": -2500,
    "willpower": -2500,
    "psyche": -2500,
    "attention": -2000,
    "empathy": -2000,
    "frighten": -2000,
    "influence": -2000,
    "initiative": -2000,
    "inspection": -2000,
    "sneak": -2000,
    "excavating": -1000,
    "farming": -1000,
    "fishing": -1000,
    "herbalism": -1000,
    "hunting": -1000,
    "locks": -1000,
    "mining": -1000,
    "skinning": -1000,
    "architecture": -1000,
    "astronomy": -1000,
    "biology": -1000,
    "civics": -1000,
    "finance": -1000,
    "gamesmanship": -1000,
    "geology": -1000,
    "history": -1000,
    "law": -1000,
    "linguistics": -1000,
    "magic": -1000,
    "medicine": -1000,
    "music": -1000,
    "navigation": -1000,
    "planes": -1000,
    "religion": -1000,
    "alchemy": -1000,
    "art": -1000,
    "cooking": -1000,
    "enchanting": -1000,
    "glassblowing": -1000,
    "jewelling": -1000,
    "leatherworking": -1000,
    "machining": -1000,
    "masoning": -1000,
    "smithing": -1000,
    "weaving": -1000,
    "woodworking": -1000,
    "archery_weapon_skill": -2500,
    "bending_weapon_skill": -2500,
    "firearms_weapon_skill": -2500,
    "natural_weapon_skill": -2500,
    "one_handed_melee_weapon_skill": -2500,
    "throwable_weapon_skill": -2500,
    "two_handed_melee_weapon_skill": -2500,
    "heavy_armor_skill": -1000,
    "light_armor_skill": -1000,
    "medium_armor_skill": -1000,
    "natural_armor_skill": -1000,
    "shield_armor_skill": -1000
   },
   "all_skill_rolls_adv": 50000,
   "all_skill_rolls_dis": -50000,
   "all_skill_rolls_plus1": 5000,
   "all_skill_rolls_minus1": -5000,
   "ascension_skill_point_range_mod_minus1": 5000
  },
  "roll_type_modifiers": {
   "roll_type_adv": {
    "armor_bending_roll": 1500,
    "challenge_roll_assistance_roll": 500,
    "contesting_roll": 10000,
    "crafting_roll": 3000,
    "damage_over_time_roll": 3000,
    "damage_roll": 7500,
    "dying_stratum_roll": 500,
    "essence_roll": 1000,
    "extra_damage_roll": 7500,
    "extra_damage_roll_taken": -5000,
    "extra_healing_roll": 3000,
    "extra_weapon_damage_roll": 5000,
    "excavation_roll": 3000,
    "gathering_roll": 3000,
    "healing_roll": 7500,
    "increase_luck_roll": 500,
    "increase_mana_roll": 1500,
    "lockpicking_roll": 3000,
    "mana_drain_roll": 1000,
    "recharge_ability_roll": 2500,
    "reduce_damage_roll": 1000,
    "reduce_luck_roll": -1000,
    "reduce_mana_roll": -1000,
    "regeneration_roll": 3000,
    "skill_roll": 25000,
    "skill_roll_assistance_roll": 1000,
    "skill_roll_retracting_roll": -1000,
    "spell_melee_attack_roll": 12000,
    "spell_ranged_attack_roll": 12000,
    "summon_roll": 500,
    "temporary_max_vitality_roll": 3000,
    "temporary_vitality_regeneration_roll": 5000,
    "temporary_vitality_roll": 3000,
    "weapon_attack_roll_assistance_roll": 500,
    "weapon_melee_attack_roll": 12000,
    "weapon_ranged_attack_roll": 12000
   },
   "roll_type_dis": {
    "armor_bending_roll": -1500,
    "challenge_roll_assistance_roll": -500,
    "contesting_roll": -10000,
    "crafting_roll": -3000,
    "damage_over_time_roll": -3000,
    "damage_roll": -7500,
    "dying_stratum_roll": -500,
    "essence_roll": -1000,
    "extra_damage_roll": -7500,
    "extra_damage_roll_taken": 5000,
    "extra_healing_roll": -3000,
    "extra_weapon_damage_roll": -5000,
    "excavation_roll": -3000,
    "gathering_roll": -3000,
    "healing_roll": -7500,
    "increase_luck_roll": -500,
    "increase_mana_roll": -1500,
    "lockpicking_roll": -3000,
    "mana_drain_roll": -1000,
    "recharge_ability_roll": -2500,
    "reduce_damage_roll": -1000,
    "reduce_luck_roll": 1000,
    "reduce_mana_roll": 1000,
    "regeneration_roll": -3000,
    "skill_roll": -25000,
    "skill_roll_assistance_roll": -1000,
    "skill_roll_retracting_roll": 1000,
    "spell_melee_attack_roll": -12000,
    "spell_ranged_attack_roll": -12000,
    "summon_roll": -500,
    "temporary_max_vitality_roll": -3000,
    "temporary_vitality_regeneration_roll": -5000,
    "temporary_vitality_roll": -3000,
    "weapon_attack_roll_assistance_roll": -500,
    "weapon_melee_attack_roll": -12000,
    "weapon_ranged_attack_roll": -12000
   },
   "roll_type_against_adv": {
    "spell_melee_attack_roll": -15000,
    "spell_ranged_attack_roll": -15000,
    "weapon_melee_attack_roll": -15000,
    "weapon_ranged_attack_roll": -15000
   },
   "roll_type_against_dis": {
    "spell_melee_attack_roll": 15000,
    "spell_ranged_attack_roll": 15000,
    "weapon_melee_attack_roll": 15000,
    "weapon_ranged_attack_roll": 15000
   },
   "roll_type_against_is_rolled_at_min": {
    "spell_melee_attack_roll": 15000,
    "spell_ranged_attack_roll": 15000,
    "weapon_melee_attack_roll": 15000,
    "weapon_ranged_attack_roll": 15000
   },
   "roll_type_against_is_rolled_at_max": {
    "spell_melee_attack_roll": -15000,
    "spell_ranged_attack_roll": -15000,
    "weapon_melee_attack_roll": -15000,
    "weapon_ranged_attack_roll": -15000
   },
   "roll_type_against_roll_result_is_halved": {
    "spell_melee_attack_roll": 15000,
    "spell_ranged_attack_roll": 15000,
    "weapon_melee_attack_roll": 15000,
    "weapon_ranged_attack_roll": 15000
   },
   "roll_type_against_roll_result_is_doubled": {
    "spell_melee_attack_roll": -15000,
    "spell_ranged_attack_roll": -15000,
    "weapon_melee_attack_roll": -15000,
    "weapon_ranged_attack_roll": -15000
   },
   "roll_type_is_rolled_at_min": {
    "armor_bending_roll": -5000,
    "challenge_roll_assistance_roll": -1000,
    "contesting_roll": -7500,
    "crafting_roll": -5000,
    "damage_over_time_roll": -5000,
    "damage_roll": -10000,
    "dying_stratum_roll": -5000,
    "essence_roll": -5000,
    "extra_damage_roll": -10000,
    "extra_damage_roll_taken": 7500,
    "extra_healing_roll": -5000,
    "extra_weapon_damage_roll": -5000,
    "excavation_roll": -5000,
    "gathering_roll": -5000,
    "healing_roll": -10000,
    "increase_luck_roll": -1000,
    "increase_mana_roll": -3000,
    "lockpicking_roll": -4000,
    "mana_drain_roll": -2500,
    "recharge_ability_roll": -5000,
    "reduce_damage_roll": -2500,
    "reduce_luck_roll": 2500,
    "reduce_mana_roll": 2500,
    "regeneration_roll": -5000,
    "skill_roll": -25000,
    "skill_roll_assistance_roll": -2500,
    "skill_roll_retracting_roll": 2500,
    "spell_melee_attack_roll": -12000,
    "spell_ranged_attack_roll": -12000,
    "summon_roll": -1000,
    "temporary_max_vitality_roll": -7500,
    "temporary_vitality_regeneration_roll": -7500,
    "temporary_vitality_roll": -5000,
    "weapon_attack_roll_assistance_roll": -1000,
    "weapon_melee_attack_roll": -20000,
    "weapon_ranged_attack_roll": -20000
   },
   "roll_type_is_rolled_at_max": {
    "armor_bending_roll": 5000,
    "challenge_roll_assistance_roll": 1000,
    "contesting_roll": 25000,
    "crafting_roll": 10000,
    "damage_over_time_roll": 10000,
    "damage_roll": 25000,
    "dying_stratum_roll": 5000,
    "essence_roll": 5000,
    "extra_damage_roll": 25000,
    "extra_damage_roll_taken": -7500,
    "extra_healing_roll": 10000,
    "extra_weapon_damage_roll": 10000,
    "excavation_roll": 10000,
    "gathering_roll": 10000,
    "healing_roll": 25000,
    "increase_luck_roll": 3000,
    "increase_mana_roll": 5000,
    "lockpicking_roll": 10000,
    "mana_drain_roll": 5000,
    "recharge_ability_roll": 5000,
    "reduce_damage_roll": 5000,
    "reduce_luck_roll": -2500,
    "reduce_mana_roll": -2500,
    "regeneration_roll": 7500,
    "skill_roll": 75000,
    "skill_roll_assistance_roll": 5000,
    "skill_roll_retracting_roll": -5000,
    "spell_melee_attack_roll": 20000,
    "spell_ranged_attack_roll": 20000,
    "summon_roll": 2500,
    "temporary_max_vitality_roll": 7500,
    "temporary_vitality_regeneration_roll": 7500,
    "temporary_vitality_roll": 5000,
    "weapon_attack_roll_assistance_roll": 2500,
    "weapon_melee_attack_roll": 20000,
    "weapon_ranged_attack_roll": 20000
   },
   "roll_type_roll_result_is_halved": {
    "armor_bending_roll": -3000,
    "challenge_roll_assistance_roll": -1000,
    "contesting_roll": -5000,
    "crafting_roll": -2500,
    "damage_over_time_roll": -5000,
    "damage_roll": -7500,
    "dying_stratum_roll": -1500,
    "essence_roll": -2500,
    "extra_damage_roll": -7500,
    "extra_damage_roll_taken": 5000,
    "extra_healing_roll": -3000,
    "extra_weapon_damage_roll": -5000,
    "excavation_roll": -2500,
    "gathering_roll": -2500,
    "healing_roll": -7500,
    "increase_luck_roll": -1500,
    "increase_mana_roll": -2500,
    "lockpicking_roll": -5000,
    "mana_drain_roll": -3000,
    "recharge_ability_roll": -5000,
    "reduce_damage_roll": -2500,
    "reduce_luck_roll": 1500,
    "reduce_mana_roll": 1500,
    "regeneration_roll": -3000,
    "skill_roll": -15000,
    "skill_roll_assistance_roll": -1500,
    "skill_roll_retracting_roll": 1500,
    "spell_melee_attack_roll": -10000,
    "spell_ranged_attack_roll": -10000,
    "summon_roll": -1000,
    "temporary_max_vitality_roll": -2500,
    "temporary_vitality_regeneration_roll": -5000,
    "temporary_vitality_roll": -2500,
    "weapon_attack_roll_assistance_roll": -1000,
    "weapon_melee_attack_roll": -10000,
    "weapon_ranged_attack_roll": -10000
   },
   "roll_type_roll_result_is_doubled": {
    "armor_bending_roll": 5000,
    "challenge_roll_assistance_roll": 2000,
    "contesting_roll": 20000,
    "crafting_roll": 15000,
    "damage_over_time_roll": 20000,
    "damage_roll": 50000,
    "dying_stratum_roll": 3500,
    "essence_roll": 7500,
    "extra_damage_roll": 50000,
    "extra_damage_roll_taken": -15000,
    "extra_healing_roll": 20000,
    "extra_weapon_damage_roll": 25000,
    "excavation_roll": 15000,
    "gathering_roll": 15000,
    "healing_roll": 50000,
    "increase_luck_roll": 6000,
    "increase_mana_roll": 10000,
    "lockpicking_roll": 25000,
    "mana_drain_roll": 10000,
    "recharge_ability_roll": 3000,
    "reduce_damage_roll": 10000,
    "reduce_luck_roll": -5000,
    "reduce_mana_roll": -5000,
    "regeneration_roll": 15000,
    "skill_roll": 100000,
    "skill_roll_assistance_roll": 7500,
    "skill_roll_retracting_roll": -7500,
    "spell_melee_attack_roll": 50000,
    "spell_ranged_attack_roll": 50000,
    "summon_roll": 10000,
    "temporary_max_vitality_roll": 12000,
    "temporary_vitality_regeneration_roll": 15000,
    "temporary_vitality_roll": 12000,
    "weapon_attack_roll_assistance_roll": 5000,
    "weapon_melee_attack_roll": 50000,
    "weapon_ranged_attack_roll": 50000
   }
  },
  "damage_modifiers": {
   "damage_type_resistance": {
    "acid": 2750,
    "cold": 2750,
    "fire": 2750,
    "force": 2750,
    "poison": 2750,
    "radiant": 2750,
    "thunder": 2750,
    "psychic": 2750,
    "necrotic": 2750,
    "lightning": 2750,
    "piercing": 4000,
    "bludgeoning": 4000,
    "slashing": 4000
   },
   "damage_type_immunity": {
    "acid": 20000,
    "cold": 20000,
    "fire": 20000,
    "force": 20000,
    "poison": 20000,
    "radiant": 20000,
    "thunder": 20000,
    "psychic": 20000,
    "necrotic": 20000,
    "lightning": 20000,
    "piercing": 50000,
    "bludgeoning": 50000,
    "slashing": 50000
   },
   "damage_type_vulnerability": {
    "acid": -10000,
    "cold": -10000,
    "fire": -10000,
    "force": -10000,
    "poison": -10000,
    "radiant": -10000,
    "thunder": -10000,
    "psychic": -10000,
    "necrotic": -10000,
    "lightning": -10000,
    "piercing": -15000,
    "bludgeoning": -15000,
    "slashing": -15000
   },
   "ignore_damage_type_resistance": {
    "acid": 3000,
    "cold": 3000,
    "fire": 3000,
    "force": 3000,
    "poison": 3000,
    "radiant": 3000,
    "thunder": 3000,
    "psychic": 3000,
    "necrotic": 3000,
    "lightning": 3000,
    "piercing": 3000,
    "bludgeoning": 3000,
    "slashing": 3000
   },
   "spell_damage_resistance": 25000,
   "spell_damage_vulnerability": 25000,
   "immune_to_spells": 100000,
   "immune_to_hostile_spells": 100000,
   "force_move_resistance": 5000,
   "immune_to_forced_movement": 10000,
   "immune_to_disarm": 5000,
   "ignores_difficult_terrain": 3000,
   "ignores_snow_and_ice_terrain": 2000,
   "walks_on_water_and_ice": 3000,
   "ground_terrain_type": 0,
   "burrows_worked_stone": 3000,
   "ignores_occupied_space_movement_penalty": 2000,
   "all_damage_output_changed_by_percentage": 5000,
   "all_incoming_damage_changed_by_percentage": 5000,
   "negate_falling_damage_in_feet": 300
  },
  "ap_modifiers": {
   "ap_change_at_start_of_turn": 15000,
   "ap_change_during_turn": 7500,
   "weapon_attack_count_change": 3000,
   "ap_change_to_caster_during_turn": 3000,
   "reaction_reset": 1000
  },
  "force_movement_modifiers": {
   "pull_ft_after_hit": 100,
   "push_ft_after_hit": 100,
   "push_any_direction": 500,
   "pull_to_caster_center": 500
  },
  "light_modifiers": {
   "bright_light_dim_light": 50,
   "limited_visibility_ft": 25,
   "magical_light": 3,
   "magical_darkness": 2
  },
  "misc_modifiers": {
   "per_one": {
    "ac_mod_magical": 1000,
    "ac_mod_non_magical": 800,
    "ac_mod": 800,
    "damage_mitigation": 7500,
    "extra_attack": 1500,
    "critical_hit_range_increase_mod": 3000,
    "weapon_ranged_attack_range_multiplier": 6000,
    "arcane_threshold": 2500,
    "enemy_move_past_movement_cost_multiplier": 4000,
    "contest_required_to_target_above_spell_level": 2000,
    "change_creature_size": 5000,
    "v_dice_multiplier": 2500,
    "spell_mana_discount": 6000,
    "damage_to_objects_multiplier": 2000,
    "squeeze_size_category_offset": 1000
   },
   "per_five": {
    "reach": 10000,
    "aura_distance_mod": 1500,
    "throwing_distance_changed_by_percentage": 250,
    "object_interaction_range_ft": 150,
    "see_through_walls_max_thickness_ft": 3000,
    "caster_may_move_target_each_turn_ft": 250,
    "hostile_spell_miscast_chance_in_encounter": 2000
   },
   "flat": {
    "unhindered_attack": 500,
    "disarmed": 250,
    "no_actions": -25000,
    "no_reactions": -5000,
    "crit_to_hit": 10000,
    "not_detected_by_truesight": 2000,
    "not_detected_by_special_senses": 8000,
    "sleeping_not_ended_by_damage": 3000,
    "revived_targets_restored_to_full_vitality": 3000,
    "ranged_attacks_do_not_reveal_position": 4000,
    "effect_only_affects_your_summons": 0,
    "trigger_only_leveled_spells": 0,
    "trigger_ignores_self_source": 0,
    "hit_to_crit": 30000,
    "gravequench": 2500,
    "fast_draw": 2000,
    "off_hand_body_damage": 2000,
    "ability_does_not_provoke_opportunity_attacks": 500,
    "ability_does_not_effect_inventory": 500,
    "boon": 500,
    "effect_can_heal_inventory": 500,
    "effect_can_only_heal_inventory": 500,
    "cannot_be_targeted_by_a_contesting_roll_ability": 15000,
    "spell_locked": -10000,
    "attack_ability_throws_the_throwing_weapon_at_target": 50,
    "draw_sheathed_weapon_for_attack_ability": 50,
    "attack_automatically_hits": 12000,
    "attack_automatically_misses": -10000,
    "acquire_abilities_while_unequipped": 50,
    "consumes_unit_per_use": 50,
    "shield_shattering_blow": 2500,
    "identify_object": 4000,
    "speaks_all_languages": 4000,
    "reads_all_languages": 4000,
    "pack_tactics": 3500,
    "immovable": 1000,
    "swap_positions_with_target": 2500,
    "can_breath_underwater": 500,
    "luck_persists_after_long_rest": 2500,
    "steal_target_held_item": 5000,
    "summon_trigger_on_kill_grants_caster_menace": 9000,
    "ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach": 2500,
    "ignore_ranged_spell_attack_roll_dis_within_an_enemy_reach": 2500,
    "ignore_all_attack_roll_dis": 12000,
    "prepare_spells_in_combat": 2500,
    "spells_ignore_damage_mitigation": 7500,
    "damage_ignores_all_damage_mitigation": 12000,
    "attacks_ignore_natural_damage_mitigation": 4000,
    "attacks_against_cannot_gain_adv": 9000,
    "concentration_roll_is_rolled_at_max": 5000,
    "concentration_roll_is_rolled_at_min": 5000,
    "ranged_weapon_attacks_ignore_cover": 9000,
    "ranged_spell_attacks_ignore_cover": 9000,
    "ranged_attacks_ignore_cover": 18000,
    "ranged_attacks_ignore_partial_cover": 9000,
    "adv_vs_own_marked_target": 12000,
    "reveals_target_essence": 2000,
    "restrained_by_caster_cannot_teleport": 7000,
    "immune_to_thought_reading": 6000,
    "reads_target_thoughts": 0,
    "ignore_spell_component_verbal": 7500,
    "ignore_spell_component_somatic": 7500,
    "ignore_spell_component_material": 10000,
    "spell_range_multiplier": 6000,
    "spells_cannot_be_counterspelled_below_level": 4000,
    "sanguine_spells_cannot_be_counterspelled": 2500,
    "spells_cannot_be_counterspelled": 3000,
    "aoe_spells_spare_allies": 5000,
    "scroll_spell_damage_multiplier": 3000,
    "carrying_capacity_multiplier": 500,
    "speed_cannot_be_reduced": 6000,
    "mana_cannot_be_reduced": 15000,
    "charges_cannot_be_reduced": 15000,
    "immune_to_size_reduction": 1500,
    "crafting_waives_nonmagical_reagents": 1000,
    "next_summon_ap_override": 0,
    "triggers_when_caster_uses_corpse": 0,
    "uses_corpse": 0,
    "summons_gain_caster_cantrips": 8000,
    "sanguine_free_max_spell_level": 0
   },
   "per_entry": {
    "weather_vision_immunity": 1000,
    "target_contesting_roll_dis_vs_spell_circle": 8000,
    "sanguine_free_for_sanguine": 2000,
    "throw_object_max_size_type": 2500,
    "ignore_damage_mitigation_damage_type": 4000,
    "extra_damage_requires_damage_type": 0,
    "damage_type_is_rolled_at_max": 6000,
    "passive_ability_applied_to_caster_after_cast": 4000
   }
  }
 },
 "triggerMultipliers": {
  "triggers_on_miss": 0.45,
  "triggers_on_hit": 0.95,
  "triggers_on_critical_hit": 0.05,
  "triggers_on_not_a_critical_hit": 0.95,
  "triggers_when_caster_takes_any_damage": 0.8,
  "triggers_when_target_takes_any_damage": 0.8,
  "triggers_when_caster_gains_status_effect": 0.5,
  "triggers_when_target_gains_status_effect": 0.5,
  "triggers_when_caster_loses_status_effect": 0.3,
  "triggers_when_target_loses_status_effect": 0.3,
  "triggers_after_long_rest": 0.15,
  "triggers_after_short_rest": 0.3,
  "triggers_after_combat_begins": 0.8,
  "triggers_on_move": 0.7,
  "triggers_on_next_move": 0.7,
  "triggers_when_target_leaves_reach": 0.7,
  "triggers_when_target_stands_up_from_prone": 0.3,
  "triggers_when_target_enters_reach": 0.7,
  "triggers_when_target_moves": 0.85,
  "triggers_on_opportunity_attack": 0.6,
  "triggers_on_opportunity_attack_against": 0.35,
  "triggers_on_kill": 0.4,
  "triggers_when_caster_turn_begins": 0.95,
  "triggers_when_caster_gains_luck": 0.15,
  "triggers_when_caster_spends_mana": 0.7,
  "triggers_when_enemy_within_ft_reduced_to_zero_vitality": 0.55,
  "triggers_on_self_zero_vitality": 0.1,
  "triggers_when_caster_begins_falling": 0.1,
  "triggers_if_roll_type_is_at_adv": 0.6,
  "triggers_if_roll_type_is_at_dis": 0.6,
  "triggers_on_next_roll_type": 0.7,
  "effect_is_reflected_back": 2,
  "triggers_if_ability_charge_is_used": 0.8,
  "triggers_if_ability_charge_is_not_used": 0.2
 },
 "triggerDefault": 0.7,
 "spellCostLevels": [
  20,
  50,
  100,
  200,
  300,
  600,
  1200,
  2500,
  5000,
  10000
 ],
 "damageCost": {
  "baseRateAttackRoll": 165,
  "naturalPremium": 2.25,
  "extraApPenalty": 0.65,
  "typeMultipliers": {
   "acid": 1.25,
   "cold": 1.25,
   "fire": 1.25,
   "lightning": 1.25,
   "thunder": 1.25,
   "poison": 1.35,
   "force": 1.5,
   "necrotic": 1.5,
   "psychic": 1.5,
   "radiant": 1.5
  }
 },
 "skillTiers": [
  {
   "variable_name": "skill_tier_0",
   "requires_skill_tier": "requires_skill_tier_0",
   "sp_required": 0,
   "skill_tier_level": 0,
   "pl_gp_value": 0
  },
  {
   "variable_name": "skill_tier_1",
   "requires_skill_tier": "requires_skill_tier_1",
   "sp_required": 1,
   "skill_tier_level": 1,
   "pl_gp_value": 1000
  },
  {
   "variable_name": "skill_tier_2",
   "requires_skill_tier": "requires_skill_tier_2",
   "sp_required": 4,
   "skill_tier_level": 2,
   "pl_gp_value": 4000
  },
  {
   "variable_name": "skill_tier_3",
   "requires_skill_tier": "requires_skill_tier_3",
   "sp_required": 7,
   "skill_tier_level": 3,
   "pl_gp_value": 7000
  },
  {
   "variable_name": "skill_tier_4",
   "requires_skill_tier": "requires_skill_tier_4",
   "sp_required": 10,
   "skill_tier_level": 4,
   "pl_gp_value": 10000
  },
  {
   "variable_name": "skill_tier_5",
   "requires_skill_tier": "requires_skill_tier_5",
   "sp_required": 13,
   "skill_tier_level": 5,
   "pl_gp_value": 13000
  },
  {
   "variable_name": "skill_tier_6",
   "requires_skill_tier": "requires_skill_tier_6",
   "sp_required": 16,
   "skill_tier_level": 6,
   "pl_gp_value": 16000
  },
  {
   "variable_name": "skill_tier_7",
   "requires_skill_tier": "requires_skill_tier_7",
   "sp_required": 19,
   "skill_tier_level": 7,
   "pl_gp_value": 19000
  },
  {
   "variable_name": "skill_tier_8",
   "requires_skill_tier": "requires_skill_tier_8",
   "sp_required": 22,
   "skill_tier_level": 8,
   "pl_gp_value": 22000
  },
  {
   "variable_name": "skill_tier_9",
   "requires_skill_tier": "requires_skill_tier_9",
   "sp_required": 25,
   "skill_tier_level": 9,
   "pl_gp_value": 25000
  },
  {
   "variable_name": "skill_tier_10",
   "requires_skill_tier": "requires_skill_tier_10",
   "sp_required": 28,
   "skill_tier_level": 10,
   "pl_gp_value": 28000
  },
  {
   "variable_name": "skill_tier_11",
   "requires_skill_tier": "requires_skill_tier_11",
   "sp_required": 40,
   "skill_tier_level": 11,
   "pl_gp_value": 40000
  },
  {
   "variable_name": "skill_tier_12",
   "requires_skill_tier": "requires_skill_tier_12",
   "sp_required": 50,
   "skill_tier_level": 12,
   "pl_gp_value": 50000
  },
  {
   "variable_name": "skill_tier_13",
   "requires_skill_tier": "requires_skill_tier_13",
   "sp_required": 60,
   "skill_tier_level": 13,
   "pl_gp_value": 60000
  },
  {
   "variable_name": "skill_tier_14",
   "requires_skill_tier": "requires_skill_tier_14",
   "sp_required": 80,
   "skill_tier_level": 14,
   "pl_gp_value": 80000
  },
  {
   "variable_name": "skill_tier_15",
   "requires_skill_tier": "requires_skill_tier_15",
   "sp_required": 100,
   "skill_tier_level": 15,
   "pl_gp_value": 100000
  },
  {
   "variable_name": "skill_tier_16",
   "requires_skill_tier": "requires_skill_tier_16",
   "sp_required": 120,
   "skill_tier_level": 16,
   "pl_gp_value": 120000
  },
  {
   "variable_name": "skill_tier_17",
   "requires_skill_tier": "requires_skill_tier_17",
   "sp_required": 140,
   "skill_tier_level": 17,
   "pl_gp_value": 140000
  },
  {
   "variable_name": "skill_tier_18",
   "requires_skill_tier": "requires_skill_tier_18",
   "sp_required": 160,
   "skill_tier_level": 18,
   "pl_gp_value": 160000
  },
  {
   "variable_name": "skill_tier_19",
   "requires_skill_tier": "requires_skill_tier_19",
   "sp_required": 180,
   "skill_tier_level": 19,
   "pl_gp_value": 180000
  },
  {
   "variable_name": "skill_tier_20",
   "requires_skill_tier": "requires_skill_tier_20",
   "sp_required": 200,
   "skill_tier_level": 20,
   "pl_gp_value": 200000
  },
  {
   "variable_name": "skill_tier_21",
   "requires_skill_tier": "requires_skill_tier_21",
   "sp_required": 220,
   "skill_tier_level": 21,
   "pl_gp_value": 220000
  },
  {
   "variable_name": "skill_tier_22",
   "requires_skill_tier": "requires_skill_tier_22",
   "sp_required": 240,
   "skill_tier_level": 22,
   "pl_gp_value": 240000
  },
  {
   "variable_name": "skill_tier_23",
   "requires_skill_tier": "requires_skill_tier_23",
   "sp_required": 260,
   "skill_tier_level": 23,
   "pl_gp_value": 260000
  },
  {
   "variable_name": "skill_tier_24",
   "requires_skill_tier": "requires_skill_tier_24",
   "sp_required": 280,
   "skill_tier_level": 24,
   "pl_gp_value": 280000
  }
 ],
 "requiresSkillTierKeys": [
  "requires_skill_tier_0",
  "requires_skill_tier_1",
  "requires_skill_tier_2",
  "requires_skill_tier_3",
  "requires_skill_tier_4",
  "requires_skill_tier_5",
  "requires_skill_tier_6",
  "requires_skill_tier_7",
  "requires_skill_tier_8",
  "requires_skill_tier_9",
  "requires_skill_tier_10",
  "requires_skill_tier_11",
  "requires_skill_tier_12",
  "requires_skill_tier_13",
  "requires_skill_tier_14",
  "requires_skill_tier_15",
  "requires_skill_tier_16",
  "requires_skill_tier_17",
  "requires_skill_tier_18",
  "requires_skill_tier_19",
  "requires_skill_tier_20",
  "requires_skill_tier_21",
  "requires_skill_tier_22",
  "requires_skill_tier_23",
  "requires_skill_tier_24"
 ],
 "abilityTypes": [
  "passive_ability",
  "full_ability",
  "ability",
  "quick_ability",
  "lair_ability",
  "trap_ability",
  "attack_ability",
  "free_ability",
  "reaction_ability",
  "opportunity_attack_ability",
  "curse",
  "menta",
  "sanguine",
  "ability_choice"
 ],
 "catalogs": {
  "rollTypes": [
   {
    "item_id": "981477BF-20AC-B5B0-A9A9-A5CB4459884C",
    "item_name": "Challenge Roll Assistance Roll",
    "variable_name": "challenge_roll_assistance_roll",
    "roll_type_pl_multiplier": 1.5
   },
   {
    "item_id": "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0",
    "item_name": "Damage Roll",
    "variable_name": "damage_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "ED5B44EA-7438-9582-A388-04EFF342E460",
    "item_name": "DC Roll",
    "variable_name": "dc_roll",
    "roll_type_pl_multiplier": 0.4
   },
   {
    "item_id": "AD80D31D-898B-66CE-0894-1335D11B1529",
    "item_name": "Contesting Roll",
    "variable_name": "contesting_roll",
    "roll_type_pl_multiplier": 0.4
   },
   {
    "item_id": "A063F21A-02D9-BA39-9C71-09C8E8122693",
    "item_name": "Essence Roll",
    "variable_name": "essence_roll",
    "roll_type_pl_multiplier": 0.4
   },
   {
    "item_id": "4FB7452A-F130-40C3-83E6-5E92C329D7B2",
    "item_name": "Healing Roll",
    "variable_name": "healing_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "52949AF2-7C18-4BA3-754E-4BF898A67AFD",
    "item_name": "Recharge Ability Roll",
    "variable_name": "recharge_ability_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "28B4E29C-5D8D-57CC-7634-761CEBD01190",
    "item_name": "Reduce Damage Roll",
    "variable_name": "reduce_damage_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "9909BE44-99AE-8780-BB12-BD99BA6E672E",
    "item_name": "Regeneration Roll",
    "variable_name": "regeneration_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "E26FC164-16F5-E38B-66F9-337FAEDE2A67",
    "item_name": "Skill Roll Assistance Roll",
    "variable_name": "skill_roll_assistance_roll",
    "roll_type_pl_multiplier": 1.5
   },
   {
    "item_id": "73ECB998-6C8E-1854-FBBB-EF02AC2AC0EE",
    "item_name": "Skill Roll Retracting Roll",
    "variable_name": "skill_roll_retracting_roll",
    "roll_type_pl_multiplier": 1.5
   },
   {
    "item_id": "5740CA49-006E-A7A0-B46B-6DDED6CD546C",
    "item_name": "Spell Melee Attack Roll",
    "variable_name": "spell_melee_attack_roll",
    "roll_type_pl_multiplier": 0.4
   },
   {
    "item_id": "DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C",
    "item_name": "Spell Ranged Attack Roll",
    "variable_name": "spell_ranged_attack_roll",
    "roll_type_pl_multiplier": 0.4
   },
   {
    "item_id": "E5016E3A-6A12-2287-5F48-5CFAC863E967",
    "item_name": "Summon Roll",
    "variable_name": "summon_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "4634635E-4E82-DFB3-8411-27A6BFB8CF0F",
    "item_name": "Temporary Vitality Regeneration Roll",
    "variable_name": "temporary_vitality_regeneration_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591",
    "item_name": "Temporary Vitality Roll",
    "variable_name": "temporary_vitality_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "1EBE0C5D-4D59-F08A-B118-13286A198ED5",
    "item_name": "Weapon Attack Roll Assistance Roll",
    "variable_name": "weapon_attack_roll_assistance_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "2FE8DFB7-FE61-4862-AF71-3523262350A0",
    "item_name": "Weapon Melee Attack Roll",
    "variable_name": "weapon_melee_attack_roll",
    "roll_type_pl_multiplier": 0.4
   },
   {
    "item_id": "3F85CA97-F9B2-A83A-FDE8-E523FD99346C",
    "item_name": "Weapon Ranged Attack Roll",
    "variable_name": "weapon_ranged_attack_roll",
    "roll_type_pl_multiplier": 0.4
   },
   {
    "item_id": "9C752002-0C85-40D8-8DC0-D43AECBB2207",
    "item_name": "Armor Bending Roll",
    "variable_name": "armor_bending_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "5DFD335C-B12A-4B3C-9FF6-560E12D9045F",
    "item_name": "Dying Stratum Roll",
    "variable_name": "dying_stratum_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "FA17A3A2-3068-C84C-1EA5-C511F71FBD8B",
    "item_name": "Gathering Roll",
    "variable_name": "gathering_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "54DC30E0-923C-4BBF-A8CC-570B0068E8A2",
    "item_name": "Crafting Roll",
    "variable_name": "crafting_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "E1C8D281-0DC7-4883-8381-5630E23AD99D",
    "item_name": "Excavation Roll",
    "variable_name": "excavation_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "77A044B7-7041-CA96-3C63-BB718B15A364",
    "item_name": "Damage Over Time Roll",
    "variable_name": "damage_over_time_roll",
    "roll_type_pl_multiplier": 1.3
   },
   {
    "item_id": "9878714A-27C3-D737-88B3-E8C1EE63A20F",
    "item_name": "Extra Damage Roll",
    "variable_name": "extra_damage_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "42A38751-5549-CDE7-528E-AED309A2B07D",
    "item_name": "Extra Weapon Damage Roll",
    "variable_name": "extra_weapon_damage_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "ABF66E1E-DA79-4329-31FA-70D981032C06",
    "item_name": "Skill Roll",
    "variable_name": "skill_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "F1CB1CCF-138F-0B16-266F-3AFE1AB8C73D",
    "item_name": "Extra Healing Roll",
    "variable_name": "extra_healing_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "C823C739-A9DE-AA5A-07B8-CB67F578F880",
    "item_name": "Increase Luck Roll",
    "variable_name": "increase_luck_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "DE5B6A74-0024-FFDB-C5C6-B0248D956515",
    "item_name": "Reduce Luck Roll",
    "variable_name": "reduce_luck_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "DB30C685-3830-9AEA-D8FA-D92FEA762982",
    "item_name": "Increase Mana Roll",
    "variable_name": "increase_mana_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "905613F5-A045-BC0A-3686-CD1EC15060C5",
    "item_name": "Reduce Mana Roll",
    "variable_name": "reduce_mana_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "99DC3B29-702D-08D0-346E-AA4359EA1D82",
    "item_name": "Extra Damage Taken Roll",
    "variable_name": "extra_damage_roll_taken",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "CC2CEB6B-CEFB-481F-911A-A47A427D5EB2",
    "item_name": "Lockpicking Roll",
    "variable_name": "lockpicking_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "5FC40097-3C6E-53ED-0947-486FCC6DE627",
    "item_name": "Mana Drain Roll",
    "variable_name": "mana_drain_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "F5BC82EE-DBDF-4594-F850-0C49E4292AC7",
    "item_name": "Temporary Max Vitality Roll",
    "variable_name": "temporary_max_vitality_roll",
    "roll_type_pl_multiplier": 1
   },
   {
    "item_id": "67B41E3F-5BF3-33A0-B459-7B8768B71933",
    "item_name": "Training Roll",
    "variable_name": "training_roll",
    "roll_type_pl_multiplier": 1
   }
  ],
  "rangeTypes": [
   {
    "item_id": "D82855E1-4BB9-93EA-6374-B9904318BC1D",
    "item_name": "Self",
    "variable_name": "self"
   },
   {
    "item_id": "7E615545-1179-6F6A-9729-0AFFCD588B31",
    "item_name": "Object Range",
    "variable_name": "object_range"
   },
   {
    "item_id": "36D59FF4-6778-96ED-8664-F5D63638C77B",
    "item_name": "Reach",
    "variable_name": "reach"
   },
   {
    "item_id": "4C761395-2532-3F23-7CBA-CA81AF5C0855",
    "item_name": "Close",
    "variable_name": "close"
   },
   {
    "item_id": "A95F219A-6288-6B17-6DB7-03DE4B97AE96",
    "item_name": "Near",
    "variable_name": "near"
   },
   {
    "item_id": "D1E8DA38-61C2-97AA-6173-4BF6157FEEE3",
    "item_name": "Far",
    "variable_name": "far"
   },
   {
    "item_id": "F6DAE84B-CBB3-5C0F-89EF-370DE841DFDA",
    "item_name": "Very Far",
    "variable_name": "very_far"
   },
   {
    "item_id": "BB47D2E8-FFFD-8A04-FC6C-FC02583750ED",
    "item_name": "Unlimited",
    "variable_name": "unlimited"
   }
  ],
  "aoeTypes": [
   {
    "item_id": "C53BE2B6-07EA-4B3B-9664-1AD286C44AF9",
    "item_name": "Circle",
    "variable_name": "circle"
   },
   {
    "item_id": "0FEF0148-6B62-4601-A8A1-A5A1A22905D8",
    "item_name": "Cone",
    "variable_name": "cone"
   },
   {
    "item_id": "0DBFA54E-F921-4835-B159-2A4AEFA62408",
    "item_name": "Cube",
    "variable_name": "cube"
   },
   {
    "item_id": "E8B770D7-1BC3-4035-A29C-B99047884CC1",
    "item_name": "Cylinder",
    "variable_name": "cylinder"
   },
   {
    "item_id": "56D1C490-B589-4B17-889A-59D866E38D54",
    "item_name": "Line",
    "variable_name": "line"
   },
   {
    "item_id": "981032B8-4F0B-43C9-8D98-67C693E4DB42",
    "item_name": "Sphere",
    "variable_name": "sphere"
   },
   {
    "item_id": "3F14BF23-09A6-4C05-AFD9-EE0CCD2596A3",
    "item_name": "Square",
    "variable_name": "square"
   }
  ],
  "skills": [
   {
    "item_id": "59C08B6D-F8D4-F9DB-81D9-0FD592094C73",
    "item_name": "Balance",
    "item_type": "defensive_skill",
    "variable_name": "balance"
   },
   {
    "item_id": "24C07918-39D5-4317-A958-BDF68B633A21",
    "item_name": "Fortitude",
    "item_type": "defensive_skill",
    "variable_name": "fortitude"
   },
   {
    "item_id": "58A62523-2588-452B-876B-61D8ACF3CCED",
    "item_name": "Psyche",
    "item_type": "defensive_skill",
    "variable_name": "psyche"
   },
   {
    "item_id": "922C5882-54DE-42D0-A5C8-8118AA1C858E",
    "item_name": "Willpower",
    "item_type": "defensive_skill",
    "variable_name": "willpower"
   },
   {
    "item_id": "F99172CC-DDEF-48D4-87F8-8B94F0071247",
    "item_name": "Attention",
    "item_type": "innate_skill",
    "variable_name": "attention"
   },
   {
    "item_id": "397C35B1-76DB-4A45-1468-E53CF797A1A3",
    "item_name": "Empathy",
    "item_type": "innate_skill",
    "variable_name": "empathy"
   },
   {
    "item_id": "30735770-7440-0C26-5FDF-86C452C0C91D",
    "item_name": "Frighten",
    "item_type": "innate_skill",
    "variable_name": "frighten"
   },
   {
    "item_id": "F5A23631-F770-1C49-79F0-E8A2B7A6DCAC",
    "item_name": "Influence",
    "item_type": "innate_skill",
    "variable_name": "influence"
   },
   {
    "item_id": "6E1A31A4-2D30-096B-BEA4-E2A1DC93A583",
    "item_name": "Initiative",
    "item_type": "innate_skill",
    "variable_name": "initiative"
   },
   {
    "item_id": "28E0D03E-86B3-FDF4-E03A-8DFA1043FE3E",
    "item_name": "Inspection",
    "item_type": "innate_skill",
    "variable_name": "inspection"
   },
   {
    "item_id": "64493E62-BCAF-27F1-2B6A-EC84DE328F66",
    "item_name": "Sneak",
    "item_type": "innate_skill",
    "variable_name": "sneak"
   },
   {
    "item_id": "9F177F51-CDAC-0012-A574-DE1B8B17A55F",
    "item_name": "Excavating",
    "item_type": "gathering_skill",
    "variable_name": "excavating"
   },
   {
    "item_id": "B3856A19-34AD-D33A-14F1-BBBE79A67DA5",
    "item_name": "Farming",
    "item_type": "gathering_skill",
    "variable_name": "farming"
   },
   {
    "item_id": "59B5B7EA-38B8-28C7-B74F-182906B4E3D7",
    "item_name": "Fishing",
    "item_type": "gathering_skill",
    "variable_name": "fishing"
   },
   {
    "item_id": "42D2DDEC-9C0C-E111-BE72-F556B47EDBFE",
    "item_name": "Herbalism",
    "item_type": "gathering_skill",
    "variable_name": "herbalism"
   },
   {
    "item_id": "964A6407-E371-E6FA-A3FC-4ECDAD3615B7",
    "item_name": "Hunting",
    "item_type": "gathering_skill",
    "variable_name": "hunting"
   },
   {
    "item_id": "1E875D11-8C3F-53D6-5256-7FF5363FB1E4",
    "item_name": "Locks",
    "item_type": "gathering_skill",
    "variable_name": "locks"
   },
   {
    "item_id": "B6B008F2-5805-C31F-842F-ED0C16D34484",
    "item_name": "Mining",
    "item_type": "gathering_skill",
    "variable_name": "mining"
   },
   {
    "item_id": "114E1810-D8A6-72C2-54B8-7EDBC5D43A57",
    "item_name": "Skinning",
    "item_type": "gathering_skill",
    "variable_name": "skinning"
   },
   {
    "item_id": "27C6E09D-9CD0-41E5-B765-18F096CD8781",
    "item_name": "Architecture",
    "item_type": "knowledge_skill",
    "variable_name": "architecture"
   },
   {
    "item_id": "432EF6B0-0DF5-5EA9-33A6-F1BE691772D0",
    "item_name": "Astronomy",
    "item_type": "knowledge_skill",
    "variable_name": "astronomy"
   },
   {
    "item_id": "AFF19B47-5E29-B9EA-1CEF-D017C9F440C3",
    "item_name": "Biology",
    "item_type": "knowledge_skill",
    "variable_name": "biology"
   },
   {
    "item_id": "432DBB43-005F-88D9-4F25-B5745D5C08D2",
    "item_name": "Civics",
    "item_type": "knowledge_skill",
    "variable_name": "civics"
   },
   {
    "item_id": "E38D3E9B-55CE-49EE-272B-C053D3C2E3B9",
    "item_name": "Finance",
    "item_type": "knowledge_skill",
    "variable_name": "finance"
   },
   {
    "item_id": "10657AA2-E10A-4C86-A814-B3A24B0CB252",
    "item_name": "Gamesmanship",
    "item_type": "knowledge_skill",
    "variable_name": "gamesmanship"
   },
   {
    "item_id": "E023B642-259E-69D7-4E72-334FE0A6EE64",
    "item_name": "Geology",
    "item_type": "knowledge_skill",
    "variable_name": "geology"
   },
   {
    "item_id": "58B3E565-2DAB-C967-766E-7D815EF1429B",
    "item_name": "History",
    "item_type": "knowledge_skill",
    "variable_name": "history"
   },
   {
    "item_id": "D7F6DF07-296F-B231-3E70-9D6B46575709",
    "item_name": "Law",
    "item_type": "knowledge_skill",
    "variable_name": "law"
   },
   {
    "item_id": "258BD584-26FB-F656-D15F-566BE8984551",
    "item_name": "Linguistics",
    "item_type": "knowledge_skill",
    "variable_name": "linguistics"
   },
   {
    "item_id": "ABE36CBD-1142-9809-FA05-C7DC4263B43C",
    "item_name": "Magic",
    "item_type": "knowledge_skill",
    "variable_name": "magic"
   },
   {
    "item_id": "761600DE-35EB-7B14-5980-F2430FFF85AB",
    "item_name": "Medicine",
    "item_type": "knowledge_skill",
    "variable_name": "medicine"
   },
   {
    "item_id": "F259DADA-89E7-F08F-E24C-DA140F84FB36",
    "item_name": "Music",
    "item_type": "knowledge_skill",
    "variable_name": "music"
   },
   {
    "item_id": "DEC0A112-9ADC-09D3-0FA7-3A59CFE8C008",
    "item_name": "Navigation",
    "item_type": "knowledge_skill",
    "variable_name": "navigation"
   },
   {
    "item_id": "1D2EB61A-67FB-4F6D-FC1B-B5C36357CA6E",
    "item_name": "Planes",
    "item_type": "knowledge_skill",
    "variable_name": "planes"
   },
   {
    "item_id": "4D0FF632-CAC9-4714-64B8-43978DD90A7E",
    "item_name": "Religion",
    "item_type": "knowledge_skill",
    "variable_name": "religion"
   },
   {
    "item_id": "86BD9ED9-4768-239D-E755-BC198290FDBE",
    "item_name": "Alchemy",
    "item_type": "crafting_skill",
    "variable_name": "alchemy"
   },
   {
    "item_id": "9CC50F9B-B8AD-B180-79BE-C309F1563800",
    "item_name": "Art",
    "item_type": "crafting_skill",
    "variable_name": "art"
   },
   {
    "item_id": "7229802A-2169-DDD4-6CCB-E755CCFAEB51",
    "item_name": "Cooking",
    "item_type": "crafting_skill",
    "variable_name": "cooking"
   },
   {
    "item_id": "E77A8B34-F880-E0E2-E6EC-42F4241F4FCC",
    "item_name": "Enchanting",
    "item_type": "crafting_skill",
    "variable_name": "enchanting"
   },
   {
    "item_id": "B27AC929-722C-685E-E93E-CE38F49FF9BE",
    "item_name": "Glassblowing",
    "item_type": "crafting_skill",
    "variable_name": "glassblowing"
   },
   {
    "item_id": "AFD61488-049C-C7FC-2B72-26CBE7EAEAFD",
    "item_name": "Jewelling",
    "item_type": "crafting_skill",
    "variable_name": "jewelling"
   },
   {
    "item_id": "F29D806E-160C-4EC2-923F-AAF1D5CDDB7E",
    "item_name": "Leatherworking",
    "item_type": "crafting_skill",
    "variable_name": "leatherworking"
   },
   {
    "item_id": "D7F51670-F6D9-5DD6-11D9-0CDBF35096A0",
    "item_name": "Machining",
    "item_type": "crafting_skill",
    "variable_name": "machining"
   },
   {
    "item_id": "6C3E6964-F138-CA3F-DB99-4BFC7AF3E4FB",
    "item_name": "Masoning",
    "item_type": "crafting_skill",
    "variable_name": "masoning"
   },
   {
    "item_id": "0A68ECAB-D224-CF73-DB51-761BCFD663FA",
    "item_name": "Smithing",
    "item_type": "crafting_skill",
    "variable_name": "smithing"
   },
   {
    "item_id": "55565C71-B55B-3D10-9DFB-7C45D95BC724",
    "item_name": "Weaving",
    "item_type": "crafting_skill",
    "variable_name": "weaving"
   },
   {
    "item_id": "E5347227-42FD-9173-6C81-ADAD3E0ED6ED",
    "item_name": "Woodworking",
    "item_type": "crafting_skill",
    "variable_name": "woodworking"
   },
   {
    "item_id": "A5B19883-CBDA-EC46-A859-96FF01651278",
    "item_name": "Abolian",
    "item_type": "language_skill",
    "variable_name": "abolian"
   },
   {
    "item_id": "B12FE4D0-480A-239A-DAF0-704850F5162D",
    "item_name": "Abyssal",
    "item_type": "language_skill",
    "variable_name": "abyssal"
   },
   {
    "item_id": "820AB0A3-F21A-3135-DB75-89DCDF09A9D0",
    "item_name": "Aquan",
    "item_type": "language_skill",
    "variable_name": "aquan"
   },
   {
    "item_id": "B1B5365D-2DE0-AA53-A729-AC28BF8C8D52",
    "item_name": "Auran",
    "item_type": "language_skill",
    "variable_name": "auran"
   },
   {
    "item_id": "81DADED4-7909-482A-BE32-76887642C172",
    "item_name": "Common",
    "item_type": "language_skill",
    "variable_name": "common"
   },
   {
    "item_id": "6EEF7655-4FC7-F5F4-0AB8-C31C31FEEDCD",
    "item_name": "Domir",
    "item_type": "language_skill",
    "variable_name": "domir"
   },
   {
    "item_id": "0700727F-6C9E-4631-1140-B57A8E442137",
    "item_name": "Draconic",
    "item_type": "language_skill",
    "variable_name": "draconic"
   },
   {
    "item_id": "94D1A00F-4795-B1DD-6981-6CE3364AF1B3",
    "item_name": "Druidic",
    "item_type": "language_skill",
    "variable_name": "druidic"
   },
   {
    "item_id": "5C346F0F-D58D-2859-92EB-A347FA56899E",
    "item_name": "Dwarvish",
    "item_type": "language_skill",
    "variable_name": "dwarvish"
   },
   {
    "item_id": "42728623-5523-5986-672E-9A9FE5DD35B5",
    "item_name": "Elvish",
    "item_type": "language_skill",
    "variable_name": "elvish"
   },
   {
    "item_id": "4A5172E6-6D97-3958-C65B-F0792A660B85",
    "item_name": "Enochian",
    "item_type": "language_skill",
    "variable_name": "enochian"
   },
   {
    "item_id": "3098C163-7B26-7757-24F1-129C467D5BDB",
    "item_name": "Gnomish",
    "item_type": "language_skill",
    "variable_name": "gnomish"
   },
   {
    "item_id": "6AB76ADB-22BC-904A-7D72-43FDCA112DD1",
    "item_name": "Grel",
    "item_type": "language_skill",
    "variable_name": "grel"
   },
   {
    "item_id": "4767BD78-9829-6FC9-BD4A-5855F322CEB7",
    "item_name": "Ignan",
    "item_type": "language_skill",
    "variable_name": "ignan"
   },
   {
    "item_id": "22CC3970-0458-63CA-3D69-82A746B9A5CD",
    "item_name": "Nagh",
    "item_type": "language_skill",
    "variable_name": "nagh"
   },
   {
    "item_id": "16A53E58-027B-DF11-6AC5-72CA13B6583A",
    "item_name": "Orcish",
    "item_type": "language_skill",
    "variable_name": "orcish"
   },
   {
    "item_id": "2CB279E7-CD79-1A21-9F32-89184886D7FC",
    "item_name": "Primordial",
    "item_type": "language_skill",
    "variable_name": "primordial"
   },
   {
    "item_id": "641E712F-1B60-C633-14BF-C4EE0DDD4AF4",
    "item_name": "Qini",
    "item_type": "language_skill",
    "variable_name": "qini"
   },
   {
    "item_id": "FBD22CAB-950F-8DAE-E052-65A88BF5205B",
    "item_name": "Sign Language",
    "item_type": "language_skill",
    "variable_name": "sign_language"
   },
   {
    "item_id": "D267CD08-6952-99E9-B19E-52EC690546BB",
    "item_name": "Sylvan",
    "item_type": "language_skill",
    "variable_name": "sylvan"
   },
   {
    "item_id": "EAC11C79-B399-7259-8556-8EDA88B7FCD8",
    "item_name": "Terran",
    "item_type": "language_skill",
    "variable_name": "terran"
   },
   {
    "item_id": "E76097FE-D47E-FD76-B7AF-8F0C40A3BCA1",
    "item_name": "Thieves Cant",
    "item_type": "language_skill",
    "variable_name": "thieves_cant"
   },
   {
    "item_id": "ABAE4F65-1A42-DEFC-21C8-11EBF883A484",
    "item_name": "Umbral",
    "item_type": "language_skill",
    "variable_name": "umbral"
   },
   {
    "item_id": "208E59A5-37B5-4DA3-97BE-8A1F540C94CD",
    "item_name": "Cymbals Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "cymbals"
   },
   {
    "item_id": "F9134996-0370-34A2-A101-13497D6631A0",
    "item_name": "Drums Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "drums"
   },
   {
    "item_id": "1DB53BE8-AB8F-CEB7-57E9-A3162F2AE4B3",
    "item_name": "Flutes Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "flutes"
   },
   {
    "item_id": "3C5D9464-C206-44E7-015F-77A700D9BD9B",
    "item_name": "Harps Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "harps"
   },
   {
    "item_id": "3B5FFB0D-26EF-B237-1F54-63CFF4004E02",
    "item_name": "Keyboards Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "keyboards"
   },
   {
    "item_id": "7D2FFF31-8526-6AC0-42A7-BBCEBA432DBE",
    "item_name": "Horns Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "horns"
   },
   {
    "item_id": "937D4758-2CD8-1DA4-E47D-7E0DFD4E9C06",
    "item_name": "Pipes Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "pipes"
   },
   {
    "item_id": "1D54B02A-B9BF-B47F-A22B-25182CE551F0",
    "item_name": "Stringed, Bow Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "stringed_bow"
   },
   {
    "item_id": "182CA00C-D9E4-C2AA-A243-B4EB4B8977B7",
    "item_name": "Stringed, Plucked Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "stringed_plucked"
   },
   {
    "item_id": "F7FCBD40-CA99-88E6-BC5B-7D2F7D3C0EDB",
    "item_name": "Zithers Skill",
    "item_type": "instrument_classification_skill",
    "variable_name": "zithers"
   },
   {
    "item_id": "45DE7B42-D548-498A-B7AB-C3DC1C660E57",
    "item_name": "Natural Weapon Skill",
    "item_type": "weapon_skill",
    "variable_name": "natural_weapon_skill"
   },
   {
    "item_id": "7BB6F92D-9C9F-D3D1-80FF-BBDBA3D06017",
    "item_name": "One-Handed Melee Weapon Skill",
    "item_type": "weapon_skill",
    "variable_name": "one_handed_melee_weapon_skill"
   },
   {
    "item_id": "8F94D454-48C2-A031-AED0-943ED5B609AF",
    "item_name": "Two-Handed Melee Weapon Skill",
    "item_type": "weapon_skill",
    "variable_name": "two_handed_melee_weapon_skill"
   },
   {
    "item_id": "2A16EE98-E160-89CD-4AC0-529BF36194D2",
    "item_name": "Archery Weapon Skill",
    "item_type": "weapon_skill",
    "variable_name": "archery_weapon_skill"
   },
   {
    "item_id": "850BDFE9-D36A-46AF-AD28-E1C533E140E3",
    "item_name": "Firearms Weapon Skill",
    "item_type": "weapon_skill",
    "variable_name": "firearms_weapon_skill"
   },
   {
    "item_id": "1A3033B2-1FA4-485A-9D0A-1CD0BC92C961",
    "item_name": "Throwable Weapon Skill",
    "item_type": "weapon_skill",
    "variable_name": "throwable_weapon_skill"
   },
   {
    "item_id": "F964C0DA-54EA-1EB5-ED00-8E9AD50FFA53",
    "item_name": "Bending Weapon Skill",
    "item_type": "weapon_skill",
    "variable_name": "bending_weapon_skill"
   },
   {
    "item_id": "937A5402-E933-4F87-8CAE-93427F47894A",
    "item_name": "Heavy Armor Skill",
    "item_type": "armor_skill",
    "variable_name": "heavy_armor_skill"
   },
   {
    "item_id": "44F9404E-77AC-1F60-68A4-4CD6AE071161",
    "item_name": "Light Armor Skill",
    "item_type": "armor_skill",
    "variable_name": "light_armor_skill"
   },
   {
    "item_id": "24495AD8-8EB9-488E-B816-5513E0A3DAA8",
    "item_name": "Medium Armor Skill",
    "item_type": "armor_skill",
    "variable_name": "medium_armor_skill"
   },
   {
    "item_id": "71E4E5C5-7AF6-9B16-90BF-8D9D6CCFD9DC",
    "item_name": "Natural Armor Skill",
    "item_type": "armor_skill",
    "variable_name": "natural_armor_skill"
   },
   {
    "item_id": "E973D6BE-E84E-4373-B134-BA8AA13BCD30",
    "item_name": "Shield Armor Skill",
    "item_type": "armor_skill",
    "variable_name": "shield_armor_skill"
   }
  ],
  "damageTypes": [
   {
    "item_id": "F66879A9-5BDC-4996-8419-AF162CFCDC5F",
    "item_name": "Acid",
    "variable_name": "acid"
   },
   {
    "item_id": "0C528CF8-1B5A-453C-9BDE-73CBBC239A2A",
    "item_name": "Bludgeoning",
    "variable_name": "bludgeoning"
   },
   {
    "item_id": "8C455214-9F98-43C7-B9BC-1C74EE60805D",
    "item_name": "Cold",
    "variable_name": "cold"
   },
   {
    "item_id": "A8469481-849E-4BBA-986E-7C418DCA06A1",
    "item_name": "Fire",
    "variable_name": "fire"
   },
   {
    "item_id": "25F9052F-B963-43CB-991E-EB315E08A549",
    "item_name": "Force",
    "variable_name": "force"
   },
   {
    "item_id": "944EC0D7-3320-42B1-B28D-68980DAA9719",
    "item_name": "Lightning",
    "variable_name": "lightning"
   },
   {
    "item_id": "D66B715F-E086-4C4B-A887-4BDB38AE32EB",
    "item_name": "Necrotic",
    "variable_name": "necrotic"
   },
   {
    "item_id": "C62E5227-0AB4-4C34-9058-DE97E36B0706",
    "item_name": "Piercing",
    "variable_name": "piercing"
   },
   {
    "item_id": "4EBFF986-A4AA-4709-BE68-E97D29B66D18",
    "item_name": "Poison",
    "variable_name": "poison"
   },
   {
    "item_id": "B61FDA44-4707-4539-B39B-54FA1FCBAA71",
    "item_name": "Psychic",
    "variable_name": "psychic"
   },
   {
    "item_id": "5850D66F-70E8-467D-9A5C-93464A5A12C4",
    "item_name": "Radiant",
    "variable_name": "radiant"
   },
   {
    "item_id": "422B9C6D-9558-47CD-AC21-1FB3B45EF33E",
    "item_name": "Slashing",
    "variable_name": "slashing"
   },
   {
    "item_id": "F79CF36E-F439-44C3-9668-050683A30F1C",
    "item_name": "Thunder",
    "variable_name": "thunder"
   }
  ],
  "equipmentSlots": [
   {
    "item_id": "F2D8C4B3-FA31-291C-995A-2046F84A289F",
    "item_name": "Air Around",
    "variable_name": "air_around"
   },
   {
    "item_id": "0B279A55-5102-D704-8A57-0C1FF4989DFA",
    "item_name": "Armor",
    "variable_name": "armor"
   },
   {
    "item_id": "F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB",
    "item_name": "Back",
    "variable_name": "back"
   },
   {
    "item_id": "E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D",
    "item_name": "Both Hands",
    "variable_name": "both_hands"
   },
   {
    "item_id": "BD255B29-389B-53DC-6116-072B1A8DDD5F",
    "item_name": "Bracers",
    "variable_name": "bracers"
   },
   {
    "item_id": "C48555B1-E374-9AAD-8CA0-C55D07AD6776",
    "item_name": "Breast",
    "variable_name": "breast"
   },
   {
    "item_id": "6203F9AE-6699-AB57-B3C7-92864A79520C",
    "item_name": "Cloak",
    "variable_name": "cloak"
   },
   {
    "item_id": "3CAA3182-3DA6-F348-CEE3-09803F221466",
    "item_name": "Clothing",
    "variable_name": "clothing"
   },
   {
    "item_id": "94805078-0B0F-FD3F-77E4-AA6EE4D2E44D",
    "item_name": "Feet",
    "variable_name": "feet"
   },
   {
    "item_id": "3805BDD7-3461-DDDB-F445-922A5A992987",
    "item_name": "Head",
    "variable_name": "head"
   },
   {
    "item_id": "AF43D701-0755-C7E2-D26F-44E6F64AC3E2",
    "item_name": "Legs",
    "variable_name": "legs"
   },
   {
    "item_id": "CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD",
    "item_name": "Main Hand",
    "variable_name": "main_hand"
   },
   {
    "item_id": "3CA73C13-5DC3-0DDF-CAD8-98D1CF573844",
    "item_name": "Natural Armor",
    "variable_name": "natural_armor"
   },
   {
    "item_id": "5EDE9876-ED2B-3B93-C683-34428B5FDA5B",
    "item_name": "Neck",
    "variable_name": "neck"
   },
   {
    "item_id": "4FF85144-67EC-9D87-AE28-15137A1A2481",
    "item_name": "Off Hand",
    "variable_name": "off_hand"
   },
   {
    "item_id": "3AD8CEE8-D487-68B1-33F0-CFE04336F9B8",
    "item_name": "Ring",
    "variable_name": "ring"
   },
   {
    "item_id": "16ABAE95-5D18-474D-ADFF-8C20FC2439F1",
    "item_name": "Tail",
    "variable_name": "tail"
   },
   {
    "item_id": "B52059C5-526B-3F8C-E906-0D40FA23A593",
    "item_name": "Waist",
    "variable_name": "waist"
   }
  ],
  "essences": [
   {
    "item_id": "22918408-67CC-4093-80E8-BF6FA8915C21",
    "item_name": "Body",
    "variable_name": "body"
   },
   {
    "item_id": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
    "item_name": "Mind",
    "variable_name": "mind"
   },
   {
    "item_id": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
    "item_name": "Soul",
    "variable_name": "soul"
   },
   {
    "item_id": "86792A8B-2070-4144-9C81-0D85706131DF",
    "item_name": "Spirit",
    "variable_name": "spirit"
   },
   {
    "item_id": "E769E451-65EE-3628-1A78-D12C9A3FF02B",
    "item_name": "Fortune",
    "variable_name": "fortune"
   },
   {
    "item_id": "7B7E8F97-6843-57CF-422C-5930CFA98B06",
    "item_name": "Luck",
    "variable_name": "luck"
   }
  ],
  "senses": [
   {
    "item_id": "3B58A8C2-F310-42FB-A71C-904904089303",
    "item_name": "Nightsight",
    "variable_name": "nightsight"
   },
   {
    "item_id": "F87E66D1-0EB2-469F-BB07-CF2CF4E26B30",
    "item_name": "Blindsight",
    "variable_name": "blindsight"
   },
   {
    "item_id": "51EFBF8C-672F-F1F8-543A-6B079320572C",
    "item_name": "Fiendsight",
    "variable_name": "fiendsight"
   },
   {
    "item_id": "E472D6BD-1A9C-F84E-AD55-F3068A3EC303",
    "item_name": "Ghostsight",
    "variable_name": "ghostsight"
   },
   {
    "item_id": "6B8E5648-B589-5F6A-DFAA-84F7E646B062",
    "item_name": "Spellsight",
    "variable_name": "spellsight"
   },
   {
    "item_id": "9F34BE02-A199-4A9C-A2C4-531CD8A1DD58",
    "item_name": "Truesight",
    "variable_name": "truesight"
   },
   {
    "item_id": "61FD588C-4A17-4190-999B-7832820C44BA",
    "item_name": "Tremorsense",
    "variable_name": "tremorsense"
   },
   {
    "item_id": "57DAF94A-7C3A-4C5B-A7A9-22729D06355F",
    "item_name": "Telepathy",
    "variable_name": "telepathy"
   }
  ],
  "speedTypes": [
   {
    "item_id": "DF516479-F164-87FA-7BB8-6F268BF1DCE7",
    "item_name": "Walking Speed",
    "variable_name": "speed_walking"
   },
   {
    "item_id": "B96061AE-3369-7E7A-B6A2-C7C8FBF2A23F",
    "item_name": "Jumping Speed",
    "variable_name": "speed_jumping"
   },
   {
    "item_id": "ED9810A9-3456-4D6B-BC5C-A1BAF5952B98",
    "item_name": "Swimming Speed",
    "variable_name": "speed_swimming"
   },
   {
    "item_id": "EDCBE2A8-CD3D-43DC-9B92-84A634BE12AE",
    "item_name": "Climbing Speed",
    "variable_name": "speed_climbing"
   },
   {
    "item_id": "F1D0A27A-43F1-4A4C-A5F8-ED9BD2D908D4",
    "item_name": "Flying Speed",
    "variable_name": "speed_flying"
   },
   {
    "item_id": "ACFB413D-15A8-835B-C821-9E101B6C4F60",
    "item_name": "Burrowing Speed",
    "variable_name": "speed_burrowing"
   },
   {
    "item_id": "3C96DE74-D9E6-4173-8671-989209A0BF97",
    "item_name": "Teleport",
    "variable_name": "teleport"
   },
   {
    "item_id": "AE7D4EB3-DC36-BD47-978F-1DBCFE2B616A",
    "item_name": "Hovering Speed",
    "variable_name": "speed_hovering"
   }
  ],
  "statusEffects": [
   {
    "item_id": "658B4D83-322B-42FA-82AB-49D3BAD33590",
    "item_name": "Ageless",
    "variable_name": "ageless",
    "status_type": "boon"
   },
   {
    "item_id": "9529EEA7-63A9-C572-ECA9-F523E87C58A8",
    "item_name": "Deafened",
    "variable_name": "deafened",
    "status_type": "bane"
   },
   {
    "item_id": "4638F1B5-48F9-4E81-95B7-E0325F40B5EF",
    "item_name": "Diseased",
    "variable_name": "diseased",
    "status_type": "bane"
   },
   {
    "item_id": "D9043BEC-2EFF-BC30-BE5C-270D7E1A68A8",
    "item_name": "Poisoned",
    "variable_name": "poisoned",
    "status_type": "bane"
   },
   {
    "item_id": "A176161E-3825-86D8-7BE7-C1524A5B19D4",
    "item_name": "Food Poisoning",
    "variable_name": "food_poisoning",
    "status_type": "bane"
   },
   {
    "item_id": "F5ACBDB4-D923-3684-57F6-FBF3F720AEFA",
    "item_name": "Prone",
    "variable_name": "prone",
    "status_type": "bane"
   },
   {
    "item_id": "095BC6BC-06F6-74E0-2B8A-FC1F32AF809B",
    "item_name": "Sleeping",
    "variable_name": "sleeping",
    "status_type": "bane"
   },
   {
    "item_id": "2A20ACDF-3BC6-B964-8FBD-F8E1AC581AA5",
    "item_name": "Suffocating",
    "variable_name": "suffocating",
    "status_type": "bane"
   },
   {
    "item_id": "1E8008FA-B68A-8DE8-48CE-0EB121008FEB",
    "item_name": "Drowning",
    "variable_name": "drowning",
    "status_type": "bane"
   },
   {
    "item_id": "7B044913-E45E-04C9-F25C-5FB8B8C503F4",
    "item_name": "Surprised",
    "variable_name": "surprised",
    "status_type": "bane"
   },
   {
    "item_id": "F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1",
    "item_name": "Unconscious",
    "variable_name": "unconscious",
    "status_type": "bane"
   },
   {
    "item_id": "799B512F-C685-9655-0AF0-8CFBE0349130",
    "item_name": "Truthsayer",
    "variable_name": "truthsayer",
    "status_type": "bane"
   },
   {
    "item_id": "DCB240F7-C033-1B9C-0E27-446C5C1F4D0C",
    "item_name": "Repelled",
    "variable_name": "repelled",
    "status_type": "bane"
   },
   {
    "item_id": "BCC91DAF-AF10-497E-241D-ACD1BEC9E80E",
    "item_name": "Silenced",
    "variable_name": "silenced",
    "status_type": "bane"
   },
   {
    "item_id": "83EAD975-053D-1DDA-4474-F2128633500E",
    "item_name": "Withering",
    "variable_name": "withering",
    "status_type": "bane"
   },
   {
    "item_id": "3E9BD118-C5FB-2C0A-01CF-72DC2C4ED0E8",
    "item_name": "Challenged",
    "variable_name": "challenged",
    "status_type": "bane"
   },
   {
    "item_id": "D5A31654-692A-B4BE-49DC-2B3360F76D4A",
    "item_name": "Confused",
    "variable_name": "confused",
    "status_type": "bane"
   },
   {
    "item_id": "B5E6379E-5869-4B82-3EB4-9ACB48D2F82A",
    "item_name": "Feebleminded",
    "variable_name": "feebleminded",
    "status_type": "bane"
   },
   {
    "item_id": "3188FB3B-C860-43D4-9BA0-40364C460385",
    "item_name": "Resting",
    "variable_name": "resting",
    "status_type": "bane"
   },
   {
    "item_id": "8A6575CF-BCA9-2E70-5ECB-21FE529FCAB6",
    "item_name": "Soul Breaker",
    "variable_name": "soul_breaker",
    "status_type": "bane"
   },
   {
    "item_id": "39F1A03D-A7C7-4E90-98FD-14F508074BC5",
    "item_name": "Unimpeded",
    "variable_name": "unimpeded",
    "status_type": "boon"
   },
   {
    "item_id": "EC8F4821-26B6-4874-86E0-2B344CDC8B4F",
    "item_name": "Reckless",
    "variable_name": "reckless",
    "status_type": "boon"
   },
   {
    "item_id": "E7FDB796-26DA-E0F5-8F88-C21FE01D923B",
    "item_name": "Concentrating",
    "variable_name": "concentrating",
    "status_type": "bane"
   },
   {
    "item_id": "AE967694-B94B-F0FF-B680-829FDE6E8D58",
    "item_name": "Searching",
    "variable_name": "searching",
    "status_type": "bane"
   },
   {
    "item_id": "A311574A-3513-44AB-8C70-3C3006F6CC40",
    "item_name": "Consecrated",
    "variable_name": "consecrated",
    "status_type": "none"
   },
   {
    "item_id": "321DA526-E48E-F202-10FC-D3A2B03485F2",
    "item_name": "Frightened",
    "variable_name": "frightened",
    "status_type": "bane"
   },
   {
    "item_id": "057BA9B2-177C-40A6-8815-8063DDDC0D9B",
    "item_name": "AOE Redirection",
    "variable_name": "aoe_redirection",
    "status_type": "none"
   },
   {
    "item_id": "83234E69-6C06-3392-256B-CB3796C180A7",
    "item_name": "Incorporeal",
    "variable_name": "incorporeal",
    "status_type": "boon"
   },
   {
    "item_id": "9DF8FF4C-33E8-8095-4876-ED3DBCD50B79",
    "item_name": "Spell Locked",
    "variable_name": "spell_locked",
    "status_type": "bane"
   },
   {
    "item_id": "2A64D1E8-7C3B-4F92-B5A8-E19D64C72F35",
    "item_name": "Abjuration Locked",
    "variable_name": "circle_locked_abjuration",
    "status_type": "bane"
   },
   {
    "item_id": "9E15B7A2-3D48-4C61-A927-F84B21D6E593",
    "item_name": "Charm Locked",
    "variable_name": "circle_locked_charm",
    "status_type": "bane"
   },
   {
    "item_id": "6C82F394-1A5D-4E76-8B34-D29E75A1C648",
    "item_name": "Conjuration Locked",
    "variable_name": "circle_locked_conjuration",
    "status_type": "bane"
   },
   {
    "item_id": "4F37A8D1-9B62-4A15-C783-28E91B5F4D76",
    "item_name": "Divination Locked",
    "variable_name": "circle_locked_divination",
    "status_type": "bane"
   },
   {
    "item_id": "8D21C6F5-4E93-4B27-A164-73F8D2E9B5A4",
    "item_name": "Evocation Locked",
    "variable_name": "circle_locked_evocation",
    "status_type": "bane"
   },
   {
    "item_id": "3B96E4A7-2F51-4D38-9C82-46A1E7D3F925",
    "item_name": "Illusion Locked",
    "variable_name": "circle_locked_illusion",
    "status_type": "bane"
   },
   {
    "item_id": "7A45D2B9-6C18-4F63-B591-82D4F6A3E1C7",
    "item_name": "Necromancy Locked",
    "variable_name": "circle_locked_necromancy",
    "status_type": "bane"
   },
   {
    "item_id": "5E63B1C4-8A27-4D95-A348-91C6E2F7D8B3",
    "item_name": "Transmutation Locked",
    "variable_name": "circle_locked_transmutation",
    "status_type": "bane"
   },
   {
    "item_id": "1D87F5A3-6B42-4C19-8E75-34A9D1B6C2F8",
    "item_name": "Arcane Sphere Locked",
    "variable_name": "sphere_locked_arcane",
    "status_type": "bane"
   },
   {
    "item_id": "9C34A6E1-5D78-4B26-A493-67F2E8D5B1A9",
    "item_name": "Divine Sphere Locked",
    "variable_name": "sphere_locked_divine",
    "status_type": "bane"
   },
   {
    "item_id": "6F92C3D7-1E85-4A64-B237-58D1A9F4E6C3",
    "item_name": "Primal Sphere Locked",
    "variable_name": "sphere_locked_primal",
    "status_type": "bane"
   },
   {
    "item_id": "1710A01B-FAF1-4684-5050-A10386685D35",
    "item_name": "Inverted",
    "variable_name": "inverted",
    "status_type": "bane"
   },
   {
    "item_id": "DB1C8E56-CBD7-09E4-0FBF-148F28A93D67",
    "item_name": "Fleeing",
    "variable_name": "fleeing",
    "status_type": "bane"
   },
   {
    "item_id": "DA2F74EB-CF67-AEEB-0DE1-376C6BB7CABA",
    "item_name": "Holy Turned",
    "variable_name": "holy_turned",
    "status_type": "bane"
   },
   {
    "item_id": "D31E3DD8-FFA1-67EC-D3F4-FCD323059091",
    "item_name": "Disguised",
    "variable_name": "disguised",
    "status_type": "boon"
   },
   {
    "item_id": "EEDD357F-C1CA-44C1-A53F-DD06EEFBA597",
    "item_name": "Holding Mastery",
    "variable_name": "holding_mastery",
    "status_type": "boon"
   },
   {
    "item_id": "D09D563D-0689-4B56-AEAA-5A254DC408A4",
    "item_name": "Performing a Melody",
    "variable_name": "performing_a_melody",
    "status_type": "boon"
   },
   {
    "item_id": "2858158E-5E6A-491B-9824-290DE8D692D8",
    "item_name": "Shadowform",
    "variable_name": "shadowform",
    "status_type": "boon"
   },
   {
    "item_id": "331C8511-F8A7-4626-AF17-48FAF062FE50",
    "item_name": "Fate Card Suit Love",
    "variable_name": "fate_card_suit_love",
    "status_type": "boon"
   },
   {
    "item_id": "D9394C92-068A-FAFA-231D-289157FD2980",
    "item_name": "Fate Card Suit War",
    "variable_name": "fate_card_suit_war",
    "status_type": "boon"
   },
   {
    "item_id": "34987D5C-BB13-7633-E28A-C3DA4BD458A7",
    "item_name": "Fate Card Suit Prosperity",
    "variable_name": "fate_card_suit_prosperity",
    "status_type": "boon"
   },
   {
    "item_id": "6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D",
    "item_name": "Fate Card Suit Change",
    "variable_name": "fate_card_suit_change",
    "status_type": "boon"
   },
   {
    "item_id": "C8163F62-7B18-8221-A60D-C9DD775682E3",
    "item_name": "Trackers Brand",
    "variable_name": "trackers_brand",
    "status_type": "bane"
   },
   {
    "item_id": "D343892B-338C-4FBE-BEA0-2015FE503F43",
    "item_name": "Donning",
    "variable_name": "donning",
    "status_type": "bane"
   },
   {
    "item_id": "398DD6E8-AFAE-EA0D-6FE9-C22842D53775",
    "item_name": "Doffing",
    "variable_name": "doffing",
    "status_type": "bane"
   },
   {
    "item_id": "ED30CCB0-1645-B97E-B9A6-867D8D0094BD",
    "item_name": "Reading",
    "variable_name": "reading",
    "status_type": "bane"
   },
   {
    "item_id": "426C7E0B-EF44-498C-10B2-B50A9E28E45C",
    "item_name": "Training",
    "variable_name": "training",
    "status_type": "bane"
   },
   {
    "item_id": "78C51D2D-5178-551C-1249-B5DDA4083098",
    "item_name": "Trapped",
    "variable_name": "trapped",
    "status_type": "boon"
   },
   {
    "item_id": "477A7977-60D2-4B9C-96B0-6ED4BFD6437E",
    "item_name": "Locked",
    "variable_name": "locked",
    "status_type": "boon"
   },
   {
    "item_id": "36C061BF-E480-4334-961C-26500150E3C4",
    "item_name": "Integrated Object",
    "variable_name": "integrated_object",
    "status_type": "none"
   },
   {
    "item_id": "B84EBE3F-B385-4CEF-9C69-648086C4CB7D",
    "item_name": "Summon Tag",
    "variable_name": "summon_tag",
    "status_type": "none"
   },
   {
    "item_id": "5AA76DEE-CE52-E021-67CD-8C701DA0E56F",
    "item_name": "Awake",
    "variable_name": "awake",
    "status_type": "none"
   },
   {
    "item_id": "FD5CB2E3-B247-274A-5B42-25F538F72661",
    "item_name": "Weary",
    "variable_name": "weary",
    "status_type": "bane"
   },
   {
    "item_id": "A707303F-CE4F-26D8-8846-B5178D3F1DB2",
    "item_name": "Nondetection Effect",
    "variable_name": "nondetection_effect",
    "status_type": "boon"
   },
   {
    "item_id": "B9DC5478-8F86-29F7-15D8-1C8CE8171F12",
    "item_name": "Spider Climb Effect",
    "variable_name": "spider_climb_effect",
    "status_type": "boon"
   },
   {
    "item_id": "A13061B6-2390-14E8-34E0-366C0E0CDE34",
    "item_name": "Water Walk Effect",
    "variable_name": "water_walk_effect",
    "status_type": "boon"
   },
   {
    "item_id": "5D939B6E-B9BC-7AC5-5143-4F00F4189EA3",
    "item_name": "Casting",
    "variable_name": "casting",
    "status_type": "bane"
   },
   {
    "item_id": "5833A733-D277-0A60-3A94-A0F355A79A80",
    "item_name": "Casting Ritual Spell",
    "variable_name": "casting_ritual_spell",
    "status_type": "bane"
   },
   {
    "item_id": "62ED7394-9C33-D41A-C426-1BC6723C999A",
    "item_name": "Crafting",
    "variable_name": "crafting",
    "status_type": "bane"
   },
   {
    "item_id": "E49AA8BA-1F60-4FD8-B3C0-852BBA3978C3",
    "item_name": "Crafting Progress",
    "variable_name": "crafting_progress",
    "status_type": "none"
   },
   {
    "item_id": "1C4D81BB-FB79-68AD-E881-28D874927FD2",
    "item_name": "Disenchanting",
    "variable_name": "disenchanting",
    "status_type": "bane"
   },
   {
    "item_id": "FF9A38A3-5F35-F083-E153-7DF41B0C0826",
    "item_name": "Lockpicking",
    "variable_name": "lockpicking",
    "status_type": "bane"
   },
   {
    "item_id": "3F171782-CC56-32DF-81B4-8C0ED89F47F4",
    "item_name": "Gathering",
    "variable_name": "gathering",
    "status_type": "bane"
   },
   {
    "item_id": "7B3E9C4A-1D62-4F08-A5D7-3E90C1B84F26",
    "item_name": "Excavation Found",
    "variable_name": "excavation_found",
    "status_type": "none"
   },
   {
    "item_id": "A64E346E-F58C-5FB7-BE30-71232C06897C",
    "item_name": "Slightly Drunk",
    "variable_name": "slightly_drunk",
    "status_type": "bane"
   },
   {
    "item_id": "67B9CAB7-1C48-41E0-AEAF-2F4A352075C1",
    "item_name": "Drunk",
    "variable_name": "drunk",
    "status_type": "bane"
   },
   {
    "item_id": "09FC38BC-6060-4B67-A33F-EF7D448F71F1",
    "item_name": "Burning",
    "variable_name": "burning",
    "status_type": "bane"
   },
   {
    "item_id": "996886D6-67F7-2A7D-0336-9324C877CAA6",
    "item_name": "Melting",
    "variable_name": "melting",
    "status_type": "bane"
   },
   {
    "item_id": "F632281D-2F16-FFDA-FB95-2E958988F01F",
    "item_name": "Corroding",
    "variable_name": "corroding",
    "status_type": "bane"
   },
   {
    "item_id": "F90FB02F-2549-6FE0-A162-CC3FA7C90C67",
    "item_name": "Dissolving",
    "variable_name": "dissolving",
    "status_type": "bane"
   },
   {
    "item_id": "E3169368-A4EF-476F-B699-5EFE62C7CE2A",
    "item_name": "Wet",
    "variable_name": "wet",
    "status_type": "bane"
   },
   {
    "item_id": "99951E6E-9801-4E3E-A684-4D111F2D6624",
    "item_name": "Chilled",
    "variable_name": "chilled",
    "status_type": "bane"
   },
   {
    "item_id": "84CD1B4A-0D7C-9385-8128-D91339F269BF",
    "item_name": "Freezing",
    "variable_name": "freezing",
    "status_type": "bane"
   },
   {
    "item_id": "6EFBE105-7632-4C64-BC04-206CEAF663E6",
    "item_name": "Frozen",
    "variable_name": "frozen",
    "status_type": "bane"
   },
   {
    "item_id": "E5452E0D-251E-4BDD-AC25-DADD00A7BEC7",
    "item_name": "Electrocuted",
    "variable_name": "electrocuted",
    "status_type": "bane"
   },
   {
    "item_id": "F711788C-2BB4-4114-8339-B3C85BE0D52A",
    "item_name": "Shocked",
    "variable_name": "shocked",
    "status_type": "bane"
   },
   {
    "item_id": "CEFF8A40-503C-FDA3-41B3-43DC06BF762D",
    "item_name": "Blinded",
    "variable_name": "blinded",
    "status_type": "bane"
   },
   {
    "item_id": "0313A4D7-C1C2-4D1B-8DD7-CC6EDBC42065",
    "item_name": "Dimmed",
    "variable_name": "dimmed",
    "status_type": "bane"
   },
   {
    "item_id": "4B74DA87-EABF-7EBA-D283-C5A1FEF483C9",
    "item_name": "Sightless",
    "variable_name": "sightless",
    "status_type": "bane"
   },
   {
    "item_id": "3E053858-D7C1-4E36-91A7-AF05EF5D0C62",
    "item_name": "Photosensitive Eye Strain",
    "variable_name": "photosensitive_eye_strain",
    "status_type": "bane"
   },
   {
    "item_id": "3C038AB7-2684-A787-1809-6C8224DBB285",
    "item_name": "Extreme Photosensitive Eye Strain",
    "variable_name": "extreme_photosensitive_eye_strain",
    "status_type": "bane"
   },
   {
    "item_id": "A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12",
    "item_name": "Piloting",
    "variable_name": "piloting",
    "status_type": "boon"
   },
   {
    "item_id": "DDC66C31-4093-84AF-18BB-093D924B8738",
    "item_name": "Piloted",
    "variable_name": "piloted",
    "status_type": "bane"
   },
   {
    "item_id": "FF8D219A-2A83-0EE5-A222-E748753E8D0B",
    "item_name": "Riding",
    "variable_name": "riding",
    "status_type": "boon"
   },
   {
    "item_id": "680EFB9E-3CFB-491F-A620-5BABF800131C",
    "item_name": "Mounted",
    "variable_name": "mounted",
    "status_type": "bane"
   },
   {
    "item_id": "F13F6A58-FE91-F24D-12BE-BE7CCAD81A40",
    "item_name": "Ridden",
    "variable_name": "ridden",
    "status_type": "bane"
   },
   {
    "item_id": "E2054884-038E-3D6E-56C5-19ABBFED8379",
    "item_name": "Obscured",
    "variable_name": "obscured",
    "status_type": "boon"
   },
   {
    "item_id": "1BA5473E-6218-6688-1C68-DCA4FEF00A97",
    "item_name": "Sneaking",
    "variable_name": "sneaking",
    "status_type": "bane"
   },
   {
    "item_id": "47667406-1B72-9D60-310B-D8CF6BFE397D",
    "item_name": "Hidden",
    "variable_name": "hidden",
    "status_type": "boon"
   },
   {
    "item_id": "84B91EEB-2FA6-D1CB-1347-75BFBDA2A6DD",
    "item_name": "Invisible",
    "variable_name": "invisible",
    "status_type": "boon"
   },
   {
    "item_id": "B6232175-C357-9A97-0ACA-7ECC67563635",
    "item_name": "Greater Invisible",
    "variable_name": "greater_invisible",
    "status_type": "boon"
   },
   {
    "item_id": "2A2845CD-949F-06E2-E6B2-98CFD5603241",
    "item_name": "Ethereal",
    "variable_name": "ethereal",
    "status_type": "boon"
   },
   {
    "item_id": "B9693027-E65E-DAFF-B2C5-7CF31927184D",
    "item_name": "Flanked",
    "variable_name": "flanked",
    "status_type": "bane"
   },
   {
    "item_id": "3A2FD2B0-28A9-62D3-CB13-A22974618CDB",
    "item_name": "Partial Cover",
    "variable_name": "partial_cover",
    "status_type": "boon"
   },
   {
    "item_id": "A126C1D6-FE3E-5578-DCC6-CBBF8742E9C1",
    "item_name": "Full Cover",
    "variable_name": "full_cover",
    "status_type": "boon"
   },
   {
    "item_id": "BE6DC590-4EB7-B297-5AC6-8E47AA4E00EF",
    "item_name": "Hunkered Down",
    "variable_name": "hunkered_down",
    "status_type": "boon"
   },
   {
    "item_id": "306CD53D-AD03-DD13-FDDF-34D9120613CD",
    "item_name": "Encumbered",
    "variable_name": "encumbered",
    "status_type": "bane"
   },
   {
    "item_id": "49F87D1B-3878-789E-D52E-65BA7F2F4218",
    "item_name": "Heavily Encumbered",
    "variable_name": "heavily_encumbered",
    "status_type": "bane"
   },
   {
    "item_id": "1AEA950E-A57E-6059-448A-E4A6FCED97A3",
    "item_name": "Shield Encumbered",
    "variable_name": "shield_encumbered",
    "status_type": "bane"
   },
   {
    "item_id": "466374FE-D89C-DB77-1809-7249A831015D",
    "item_name": "Armor Encumbered",
    "variable_name": "armor_encumbered",
    "status_type": "bane"
   },
   {
    "item_id": "10278E95-5320-A57E-471F-C3E7AEFA70BA",
    "item_name": "Bolstered",
    "variable_name": "bolstered",
    "status_type": "boon"
   },
   {
    "item_id": "EB6FB558-7427-A647-8F46-D2E8C25F1F60",
    "item_name": "Exhausted",
    "variable_name": "exhausted",
    "status_type": "bane"
   },
   {
    "item_id": "BF31EE0A-5B3C-370B-0118-96B067CFD929",
    "item_name": "Paralyzed",
    "variable_name": "paralyzed",
    "status_type": "bane"
   },
   {
    "item_id": "F2CD1603-38A4-85E9-D148-CE3D429310A2",
    "item_name": "Banished",
    "variable_name": "banished",
    "status_type": "bane"
   },
   {
    "item_id": "D218F4FB-5693-87B9-93C1-776FC1F7ED90",
    "item_name": "Stunned",
    "variable_name": "stunned",
    "status_type": "bane"
   },
   {
    "item_id": "B404E7CA-C073-473E-A799-A71601A22DE5",
    "item_name": "Dazed",
    "variable_name": "dazed",
    "status_type": "bane"
   },
   {
    "item_id": "6CCB9287-4420-962A-2952-7469394A5C7A",
    "item_name": "Backlash",
    "variable_name": "backlash",
    "status_type": "bane"
   },
   {
    "item_id": "DD4C0995-C3D2-43A3-CFC7-226C3005274C",
    "item_name": "Charmed",
    "variable_name": "charmed",
    "status_type": "bane"
   },
   {
    "item_id": "D2E7BA2C-562D-D4AC-7F71-13E4AC540484",
    "item_name": "Dominated",
    "variable_name": "dominated",
    "status_type": "bane"
   },
   {
    "item_id": "185D46F5-09E2-1921-F721-FDD0A2AB3EFC",
    "item_name": "Possessed",
    "variable_name": "possessed",
    "status_type": "bane"
   },
   {
    "item_id": "E4A34093-AAAB-6453-BCE0-FBA65EE263AD",
    "item_name": "Grappling",
    "variable_name": "grappling",
    "status_type": "boon"
   },
   {
    "item_id": "0C2A8037-B0BC-8300-C818-198881B00E7D",
    "item_name": "Grappled",
    "variable_name": "grappled",
    "status_type": "bane"
   },
   {
    "item_id": "E34AF232-5438-88FC-9A9F-73850CCCFD51",
    "item_name": "Restrained",
    "variable_name": "restrained",
    "status_type": "bane"
   },
   {
    "item_id": "F40E19A3-FC86-187F-050E-8C8B69761353",
    "item_name": "Immobile",
    "variable_name": "immobile",
    "status_type": "bane"
   },
   {
    "item_id": "BC6671F6-DEDF-9C1B-C459-226E7388A00C",
    "item_name": "Slowed",
    "variable_name": "slowed",
    "status_type": "bane"
   },
   {
    "item_id": "90D15611-2833-46D6-A72E-04C16C87972F",
    "item_name": "Hindered",
    "variable_name": "hindered",
    "status_type": "bane"
   },
   {
    "item_id": "9FD8A4D0-B09B-C068-D475-7EAB358D1A1E",
    "item_name": "Hamstrung",
    "variable_name": "hamstrung",
    "status_type": "bane"
   },
   {
    "item_id": "64318AE9-0187-4C71-9163-084694BCE180",
    "item_name": "Sluggish",
    "variable_name": "sluggish",
    "status_type": "bane"
   },
   {
    "item_id": "75B1C2F6-8E21-0ED0-32AD-C49B68804CCC",
    "item_name": "Rushed",
    "variable_name": "rushed",
    "status_type": "boon"
   },
   {
    "item_id": "091B2BEE-7F61-D7DB-0CF1-6D255F4B7663",
    "item_name": "Hasted",
    "variable_name": "hasted",
    "status_type": "boon"
   },
   {
    "item_id": "EAA88590-DB1D-7C46-F523-E87A31912777",
    "item_name": "Dizzy",
    "variable_name": "dizzy",
    "status_type": "bane"
   },
   {
    "item_id": "9853CC89-CE34-4077-5453-59605542265C",
    "item_name": "Staggered",
    "variable_name": "staggered",
    "status_type": "bane"
   },
   {
    "item_id": "BE55F5A2-74F7-63D0-D169-900934E2E26E",
    "item_name": "Impaired",
    "variable_name": "impaired",
    "status_type": "bane"
   },
   {
    "item_id": "3AD27E05-55EB-4B79-83F6-FC88ADEBD342",
    "item_name": "Exposed",
    "variable_name": "exposed",
    "status_type": "bane"
   },
   {
    "item_id": "75682F12-AB67-401B-97D7-F1B7354333CA",
    "item_name": "Squeezed",
    "variable_name": "squeezed",
    "status_type": "bane"
   },
   {
    "item_id": "B45813FE-321A-EC7F-F008-12B8FD33B524",
    "item_name": "Very Squeezed",
    "variable_name": "very_squeezed",
    "status_type": "bane"
   },
   {
    "item_id": "98FEA101-0910-41AE-9E20-E126C8B73AFC",
    "item_name": "Protected",
    "variable_name": "protected",
    "status_type": "boon"
   },
   {
    "item_id": "256BCFFB-B0BF-7C7A-B238-3126CA2AC20C",
    "item_name": "Powerful",
    "variable_name": "powerful",
    "status_type": "boon"
   },
   {
    "item_id": "091CBC18-FF1D-6072-3190-90EFAEDDE6F5",
    "item_name": "Greater Powerful",
    "variable_name": "greater_powerful",
    "status_type": "boon"
   },
   {
    "item_id": "C518B122-A108-4EA3-B140-E6211C1071BB",
    "item_name": "Empowered",
    "variable_name": "empowered",
    "status_type": "boon"
   },
   {
    "item_id": "B49068EF-8A0A-0002-3476-E214504C3570",
    "item_name": "Weakened",
    "variable_name": "weakened",
    "status_type": "bane"
   },
   {
    "item_id": "CAD2A16E-0DB5-91C5-F7F4-24F46B28011C",
    "item_name": "Greater Weakened",
    "variable_name": "greater_weakened",
    "status_type": "bane"
   },
   {
    "item_id": "F450C824-98D3-D0B1-D6B1-C326F15F1578",
    "item_name": "Enfeebled",
    "variable_name": "enfeebled",
    "status_type": "bane"
   },
   {
    "item_id": "DD53CA8E-DF3D-9AF4-49CB-9C61926BBB93",
    "item_name": "Defenseless",
    "variable_name": "defenseless",
    "status_type": "bane"
   },
   {
    "item_id": "F55C0D31-091D-0F3F-74F0-AEE4C20BE1ED",
    "item_name": "Vulnerable",
    "variable_name": "vulnerable",
    "status_type": "bane"
   },
   {
    "item_id": "60912827-B1B3-E9D7-6FBF-1FE976DDD04E",
    "item_name": "Shelled",
    "variable_name": "shelled",
    "status_type": "boon"
   },
   {
    "item_id": "8912E655-C826-4CF6-8F3C-B036AC710CE3",
    "item_name": "Resistant",
    "variable_name": "resistant",
    "status_type": "boon"
   },
   {
    "item_id": "1194F357-C419-2931-27B4-3B56F26BFBA7",
    "item_name": "Invulnerable",
    "variable_name": "invulnerable",
    "status_type": "boon"
   },
   {
    "item_id": "88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC",
    "item_name": "Hunger and Thirst Tick",
    "variable_name": "hunger_and_thirst_tick",
    "status_type": "none"
   },
   {
    "item_id": "6FAF0CD0-26E2-60A3-0608-A3C8E1828027",
    "item_name": "Thirsty",
    "variable_name": "thirsty",
    "status_type": "bane"
   },
   {
    "item_id": "C1F4E2B6-DA45-8CAC-322D-C5DF54FFC418",
    "item_name": "Parched",
    "variable_name": "parched",
    "status_type": "bane"
   },
   {
    "item_id": "2611657A-9C0A-4680-AB51-62235A6D8D79",
    "item_name": "Desiccating",
    "variable_name": "desiccating",
    "status_type": "bane"
   },
   {
    "item_id": "5672B433-B59D-561E-B4C6-79565C46B3CA",
    "item_name": "Hungry",
    "variable_name": "hungry",
    "status_type": "bane"
   },
   {
    "item_id": "7780B669-28AA-680E-D28D-397B05A15FC6",
    "item_name": "Starving",
    "variable_name": "starving",
    "status_type": "bane"
   },
   {
    "item_id": "457ADEAA-1D5D-9AB4-EFC9-2B7120C78BAA",
    "item_name": "Petrified",
    "variable_name": "petrified",
    "status_type": "bane"
   },
   {
    "item_id": "DFCF49C0-D5BC-C56F-A7C5-DC8D134ED7D7",
    "item_name": "Petrifying",
    "variable_name": "petrifying",
    "status_type": "bane"
   },
   {
    "item_id": "3BE713AB-37D7-630B-C1F8-9470784BA33E",
    "item_name": "Bleeding",
    "variable_name": "bleeding",
    "status_type": "bane"
   },
   {
    "item_id": "22E33A8E-DF5D-2596-8E2D-0E8A8528E47C",
    "item_name": "Moderate Bleeding",
    "variable_name": "moderate_bleeding",
    "status_type": "bane"
   },
   {
    "item_id": "BAAA237B-1AA7-0409-5BC7-1A6720573069",
    "item_name": "Severe Bleeding",
    "variable_name": "severe_bleeding",
    "status_type": "bane"
   },
   {
    "item_id": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
    "item_name": "Maimed",
    "variable_name": "maimed",
    "status_type": "bane"
   },
   {
    "item_id": "9437F344-1461-B4C0-E196-6BA1A34ADC94",
    "item_name": "Maimed 1",
    "variable_name": "maimed_1",
    "status_type": "bane"
   },
   {
    "item_id": "9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B",
    "item_name": "Maimed 2",
    "variable_name": "maimed_2",
    "status_type": "bane"
   },
   {
    "item_id": "46F27428-2B73-50F7-6F0C-D4FAFDB753ED",
    "item_name": "Maimed 3",
    "variable_name": "maimed_3",
    "status_type": "bane"
   },
   {
    "item_id": "4D27433B-6F72-47BB-9A60-B80493F22D65",
    "item_name": "Maimed 4",
    "variable_name": "maimed_4",
    "status_type": "bane"
   },
   {
    "item_id": "E4994653-49B3-D768-35C1-36C8DE40CC1A",
    "item_name": "Maimed 5",
    "variable_name": "maimed_5",
    "status_type": "bane"
   },
   {
    "item_id": "5C557D5A-B85F-DF45-3CF6-6739D2BD70EC",
    "item_name": "Maimed 6",
    "variable_name": "maimed_6",
    "status_type": "bane"
   },
   {
    "item_id": "44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4",
    "item_name": "Maimed 7",
    "variable_name": "maimed_7",
    "status_type": "bane"
   },
   {
    "item_id": "1DEE12B6-D23A-7470-812E-CE4C77AAD395",
    "item_name": "Maimed 8",
    "variable_name": "maimed_8",
    "status_type": "bane"
   },
   {
    "item_id": "4AEF8F40-B779-C0AD-4455-2DABE7B1D14B",
    "item_name": "Maimed 9",
    "variable_name": "maimed_9",
    "status_type": "bane"
   },
   {
    "item_id": "A230F5E6-B6AD-8091-4F59-5E454776B4FA",
    "item_name": "Maimed 10",
    "variable_name": "maimed_10",
    "status_type": "bane"
   },
   {
    "item_id": "CEF623E6-6A71-37FD-29C7-12988B43151A",
    "item_name": "Arcane Fatigue",
    "variable_name": "arcane_fatigue",
    "status_type": "bane"
   },
   {
    "item_id": "F8E5F274-2F31-1340-6167-ED9131E81A88",
    "item_name": "Arcane Fatigue 1",
    "variable_name": "arcane_fatigue_1",
    "status_type": "bane"
   },
   {
    "item_id": "E18A79D1-AA69-7F80-2579-78B583E0771B",
    "item_name": "Arcane Fatigue 2",
    "variable_name": "arcane_fatigue_2",
    "status_type": "bane"
   },
   {
    "item_id": "20F461C2-67CC-BEF6-E02A-4E9A464EC397",
    "item_name": "Arcane Fatigue 3",
    "variable_name": "arcane_fatigue_3",
    "status_type": "bane"
   },
   {
    "item_id": "EF165E68-DD93-90C8-A848-01D93B041CBD",
    "item_name": "Arcane Fatigue 4",
    "variable_name": "arcane_fatigue_4",
    "status_type": "bane"
   },
   {
    "item_id": "DA5A18C5-FDE5-D20B-0E3B-07B68E6C7C1C",
    "item_name": "Arcane Fatigue 5",
    "variable_name": "arcane_fatigue_5",
    "status_type": "bane"
   },
   {
    "item_id": "683632D7-756C-0165-9E94-27EA95A53A53",
    "item_name": "Arcane Fatigue 6",
    "variable_name": "arcane_fatigue_6",
    "status_type": "bane"
   },
   {
    "item_id": "E19F0AB8-E760-D84A-85C3-1A14E7DFE399",
    "item_name": "Arcane Fatigue 7",
    "variable_name": "arcane_fatigue_7",
    "status_type": "bane"
   },
   {
    "item_id": "5F87B80F-A8E4-A3BE-6FC6-3B5BC0A669E9",
    "item_name": "Arcane Fatigue 8",
    "variable_name": "arcane_fatigue_8",
    "status_type": "bane"
   },
   {
    "item_id": "E29189CC-A2FA-B06A-5DBD-8551A3259829",
    "item_name": "Arcane Fatigue 9",
    "variable_name": "arcane_fatigue_9",
    "status_type": "bane"
   },
   {
    "item_id": "BDAF9378-AA7A-445F-D24F-8E6A0EE84456",
    "item_name": "Arcane Fatigue 10",
    "variable_name": "arcane_fatigue_10",
    "status_type": "bane"
   },
   {
    "item_id": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
    "item_name": "Blighted",
    "variable_name": "blighted",
    "status_type": "bane"
   },
   {
    "item_id": "5CB84B6E-E636-B4A3-3864-910DBD3B63B4",
    "item_name": "Blighted 1",
    "variable_name": "blighted_1",
    "status_type": "bane"
   },
   {
    "item_id": "1B912A78-2334-D265-2674-7AD764534D56",
    "item_name": "Blighted 2",
    "variable_name": "blighted_2",
    "status_type": "bane"
   },
   {
    "item_id": "7F938839-F44A-FA43-05FA-BAAF79B7A05B",
    "item_name": "Blighted 3",
    "variable_name": "blighted_3",
    "status_type": "bane"
   },
   {
    "item_id": "FCC88F77-777D-56B1-913E-E676C90E39E3",
    "item_name": "Blighted 4",
    "variable_name": "blighted_4",
    "status_type": "bane"
   },
   {
    "item_id": "655383C0-8B0C-3B33-694D-26404400626D",
    "item_name": "Blighted 5",
    "variable_name": "blighted_5",
    "status_type": "bane"
   },
   {
    "item_id": "36B68995-C875-199D-20E8-1A1098F846B0",
    "item_name": "Blighted 6",
    "variable_name": "blighted_6",
    "status_type": "bane"
   },
   {
    "item_id": "D9668790-E866-861A-FDE0-D23D2903B0FA",
    "item_name": "Blighted 7",
    "variable_name": "blighted_7",
    "status_type": "bane"
   },
   {
    "item_id": "90D143BD-9CC9-06F7-F339-03F50C27D958",
    "item_name": "Blighted 8",
    "variable_name": "blighted_8",
    "status_type": "bane"
   },
   {
    "item_id": "8A3B8D76-ED7A-560A-166D-73093DE6F4E9",
    "item_name": "Blighted 9",
    "variable_name": "blighted_9",
    "status_type": "bane"
   },
   {
    "item_id": "E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30",
    "item_name": "Blighted 10",
    "variable_name": "blighted_10",
    "status_type": "bane"
   },
   {
    "item_id": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
    "item_name": "Shielded",
    "variable_name": "shielded",
    "status_type": "boon"
   },
   {
    "item_id": "BF823982-6FC8-51F0-F452-5BE1C949FBA6",
    "item_name": "Shielded 1",
    "variable_name": "shielded_1",
    "status_type": "boon"
   },
   {
    "item_id": "36DA5B89-CA08-3940-E798-FCAE6BE775D5",
    "item_name": "Shielded 2",
    "variable_name": "shielded_2",
    "status_type": "boon"
   },
   {
    "item_id": "8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368",
    "item_name": "Shielded 3",
    "variable_name": "shielded_3",
    "status_type": "boon"
   },
   {
    "item_id": "E5314BED-1269-3A65-8C15-01E80A3A8E23",
    "item_name": "Shielded 4",
    "variable_name": "shielded_4",
    "status_type": "boon"
   },
   {
    "item_id": "E614D75F-CF27-D169-3D91-0D33D9CE354B",
    "item_name": "Shielded 5",
    "variable_name": "shielded_5",
    "status_type": "boon"
   },
   {
    "item_id": "A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A",
    "item_name": "Shielded 6",
    "variable_name": "shielded_6",
    "status_type": "boon"
   },
   {
    "item_id": "631AAD91-F6A5-879D-5BD6-B7F885AA7FC9",
    "item_name": "Shielded 7",
    "variable_name": "shielded_7",
    "status_type": "boon"
   },
   {
    "item_id": "BF1C1C48-8171-90B8-CD83-F2768348629F",
    "item_name": "Shielded 8",
    "variable_name": "shielded_8",
    "status_type": "boon"
   },
   {
    "item_id": "2A63EC91-E5B1-17B4-DFB0-199F9E2084A5",
    "item_name": "Shielded 9",
    "variable_name": "shielded_9",
    "status_type": "boon"
   },
   {
    "item_id": "01B0F693-7D8A-C588-9B34-CD1F323D8433",
    "item_name": "Shielded 10",
    "variable_name": "shielded_10",
    "status_type": "boon"
   },
   {
    "item_id": "D98B076A-3A38-E225-B8E3-A646C69AA29D",
    "item_name": "Judgement",
    "variable_name": "judgement",
    "status_type": "bane"
   },
   {
    "item_id": "430F1BE4-6522-4468-8E27-426B23D003BF",
    "item_name": "Judgement 1",
    "variable_name": "judgement_1",
    "status_type": "bane"
   },
   {
    "item_id": "9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58",
    "item_name": "Judgement 2",
    "variable_name": "judgement_2",
    "status_type": "bane"
   },
   {
    "item_id": "90FB0BFB-6186-5E01-FD8B-0315D6DFB809",
    "item_name": "Judgement 3",
    "variable_name": "judgement_3",
    "status_type": "bane"
   },
   {
    "item_id": "CDC5CFDA-B09C-4A68-820D-6C74D90BD595",
    "item_name": "Mirror Images",
    "variable_name": "mirror_image_effect",
    "status_type": "boon"
   },
   {
    "item_id": "D9B64F38-A817-47B8-AB07-60D59F3D893C",
    "item_name": "Mirror Image 1",
    "variable_name": "mirror_image_1",
    "status_type": "boon"
   },
   {
    "item_id": "AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139",
    "item_name": "Mirror Image 2",
    "variable_name": "mirror_image_2",
    "status_type": "boon"
   },
   {
    "item_id": "479A4B5C-43F3-3559-979B-5BDA8A379F07",
    "item_name": "Mirror Image 3",
    "variable_name": "mirror_image_3",
    "status_type": "boon"
   },
   {
    "item_id": "80585488-CC4B-4A80-8ECE-CB1CE83F2407",
    "item_name": "Fully Rested",
    "variable_name": "fully_rested",
    "status_type": "none"
   },
   {
    "item_id": "82788F70-EBEF-44C4-80E7-6622AD20DD60",
    "item_name": "Invigorated",
    "variable_name": "invigorated",
    "status_type": "none"
   },
   {
    "item_id": "FF30B76E-785D-2CAF-FC66-C131D0548808",
    "item_name": "Fresh",
    "variable_name": "fresh",
    "status_type": "none"
   },
   {
    "item_id": "658483AA-34DE-74E5-C974-E3E202C31CC7",
    "item_name": "Barely Wounded",
    "variable_name": "barely_wounded",
    "status_type": "none"
   },
   {
    "item_id": "C97076EF-FED9-19B4-D109-C22F9BC740E8",
    "item_name": "Wounded",
    "variable_name": "wounded",
    "status_type": "none"
   },
   {
    "item_id": "44B8792E-632E-2651-C666-67DFD181E92A",
    "item_name": "Bloodied",
    "variable_name": "bloodied",
    "status_type": "none"
   },
   {
    "item_id": "298BE1DD-2917-476E-D79C-92CF8C598926",
    "item_name": "Well Bloodied",
    "variable_name": "well_bloodied",
    "status_type": "none"
   },
   {
    "item_id": "D5DE14C4-3194-87BC-D767-6D45BDD90552",
    "item_name": "On Deaths Door",
    "variable_name": "on_deaths_door",
    "status_type": "none"
   },
   {
    "item_id": "8AE129AF-52D8-CCE8-706A-85767DB52740",
    "item_name": "Dying",
    "variable_name": "dying",
    "status_type": "bane"
   },
   {
    "item_id": "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA",
    "item_name": "Dead",
    "variable_name": "dead",
    "status_type": "bane"
   },
   {
    "item_id": "F07C595F-D2DC-4CE9-904E-A4D73ABF9DEA",
    "item_name": "Stabilized",
    "variable_name": "stabilized",
    "status_type": "boon"
   },
   {
    "item_id": "99C862B9-D6AE-4E18-7803-A6F9B42A88E1",
    "item_name": "Crippled",
    "variable_name": "crippled",
    "status_type": "bane"
   },
   {
    "item_id": "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944",
    "item_name": "Dying State",
    "variable_name": "dying_state",
    "status_type": "bane"
   },
   {
    "item_id": "EE063289-1AF3-41CF-B73C-64A0556E6D07",
    "item_name": "Dying State 1",
    "variable_name": "dying_state_1",
    "status_type": "bane"
   },
   {
    "item_id": "2EAAA2E8-1B9C-196D-3E58-C29C09FF8492",
    "item_name": "Dying State 2",
    "variable_name": "dying_state_2",
    "status_type": "bane"
   },
   {
    "item_id": "A9678CB1-11D3-55A3-E3C9-F342B2E40980",
    "item_name": "Dying State 3",
    "variable_name": "dying_state_3",
    "status_type": "bane"
   },
   {
    "item_id": "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64",
    "item_name": "Recovery State",
    "variable_name": "recovery_state",
    "status_type": "boon"
   },
   {
    "item_id": "553734EC-33D3-4527-AB2E-EF48ACED8DF0",
    "item_name": "Recovery State 1",
    "variable_name": "recovery_state_1",
    "status_type": "boon"
   },
   {
    "item_id": "9AA7588A-4575-9550-343D-6ADB0C74C17F",
    "item_name": "Recovery State 2",
    "variable_name": "recovery_state_2",
    "status_type": "boon"
   },
   {
    "item_id": "660E3133-44D8-E79F-C0ED-A26CE31D6E32",
    "item_name": "Recovery State 3",
    "variable_name": "recovery_state_3",
    "status_type": "boon"
   },
   {
    "item_id": "62E83DEB-4569-AE3A-F671-FF514C508FD2",
    "item_name": "Rotting",
    "variable_name": "rotting",
    "status_type": "bane"
   },
   {
    "item_id": "F7A1C3B2-5D64-4E18-9A70-2C8B41D5E093",
    "item_name": "Spoiling",
    "variable_name": "spoiling",
    "status_type": "bane"
   },
   {
    "item_id": "10C28483-A0E9-467F-993B-CBC440546A52",
    "item_name": "Received Prayer of Healing",
    "variable_name": "received_prayer_of_healing",
    "status_type": "none"
   }
  ],
  "statusQuantityGroups": {
   "burning": {
    "max": 10,
    "decay": {
     "die": 4,
     "on": 1,
     "lose": 1
    },
    "aliases": {
     "melting": 10
    }
   },
   "corroding": {
    "max": 10,
    "decay": {
     "die": 4,
     "on": 1,
     "lose": 1
    },
    "aliases": {
     "dissolving": 6
    }
   },
   "bleeding": {
    "max": 10,
    "decay": null,
    "aliases": {
     "moderate_bleeding": 3,
     "severe_bleeding": 5
    }
   },
   "maimed": {
    "max": 9,
    "decay": null,
    "aliases": {
     "maimed_1": 1,
     "maimed_2": 2,
     "maimed_3": 3,
     "maimed_4": 4,
     "maimed_5": 5,
     "maimed_6": 6,
     "maimed_7": 7,
     "maimed_8": 8,
     "maimed_9": 9
    },
    "overflow": "dead"
   },
   "mirror_image_effect": {
    "max": 3,
    "decay": null,
    "aliases": {
     "mirror_image_1": 1,
     "mirror_image_2": 2,
     "mirror_image_3": 3
    }
   },
   "arcane_fatigue": {
    "max": 10,
    "decay": null,
    "aliases": {
     "arcane_fatigue_1": 1,
     "arcane_fatigue_2": 2,
     "arcane_fatigue_3": 3,
     "arcane_fatigue_4": 4,
     "arcane_fatigue_5": 5,
     "arcane_fatigue_6": 6,
     "arcane_fatigue_7": 7,
     "arcane_fatigue_8": 8,
     "arcane_fatigue_9": 9,
     "arcane_fatigue_10": 10
    }
   },
   "blighted": {
    "max": 10,
    "decay": null,
    "aliases": {
     "blighted_1": 1,
     "blighted_2": 2,
     "blighted_3": 3,
     "blighted_4": 4,
     "blighted_5": 5,
     "blighted_6": 6,
     "blighted_7": 7,
     "blighted_8": 8,
     "blighted_9": 9,
     "blighted_10": 10
    }
   },
   "shielded": {
    "max": 10,
    "decay": null,
    "aliases": {
     "shielded_1": 1,
     "shielded_2": 2,
     "shielded_3": 3,
     "shielded_4": 4,
     "shielded_5": 5,
     "shielded_6": 6,
     "shielded_7": 7,
     "shielded_8": 8,
     "shielded_9": 9,
     "shielded_10": 10
    }
   }
  }
 },
 "constants": {
  "sizeGatedDefenseLayers": [
   "immune_to_forced_movement_from_size_category_number_below",
   "immune_to_status_effect_prone_from_size_category_number_below"
  ],
  "orbQueueDefaultSlots": 3,
  "channelOrbQtyMax": 20,
  "lockpickPctMin": -90,
  "lockpickPctMax": 1000
 },
 "generated_at": "2026-11-04T13:46:31.552Z"
}